import { Directive, Pipe, Injectable, EventEmitter, KeyValueDiffers, ChangeDetectorRef, Component, ChangeDetectionStrategy, Injector, Input, Output, ContentChild, TemplateRef, ɵɵdefineInjectable, LOCALE_ID, ComponentFactoryResolver, ViewContainerRef, NgModule } from '@angular/core';
import { EntityListModuleConfigToken } from '@mt-ng2/entity-list-module-config';
import { DatePipe, UpperCasePipe, LowerCasePipe, DecimalPipe, CurrencyPipe, PercentPipe, DOCUMENT, formatNumber, CommonModule } from '@angular/common';
import { IsPrimaryPipe, PhonePipe } from '@mt-ng2/phone-control';
import { format } from '@mt-ng2/format-functions';
import { ComponentErrorHandler } from '@mt-ng2/component-error-handler';
import { common } from '@mt-ng2/common-functions';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MtAlertsModule } from '@mt-ng2/alerts-module';
import { VisibilityModule } from '@mt-ng2/visibility-module';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/phone-control';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@mt-ng2/alerts-module';
import * as ɵngcc4 from '@mt-ng2/visibility-module';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';

function EntityListComponent_entity_list_print_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "entity-list-print", 7);
    ɵngcc0.ɵɵlistener("printModeChange", function EntityListComponent_entity_list_print_3_Template_entity_list_print_printModeChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.printModeChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} }
function EntityListComponent_entity_list_export_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "entity-list-export", 8);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("entityListConfig", ctx_r1.entityListConfig);
} }
function EntityListComponent_tr_14_th_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("fa-check-square-o", ctx_r15.selectHelper.isAllItemsSelected(ctx_r15.entities))("fa-square-o", !ctx_r15.selectHelper.isAllItemsSelected(ctx_r15.entities));
} }
function EntityListComponent_tr_14_th_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 12);
    ɵngcc0.ɵɵlistener("click", function EntityListComponent_tr_14_th_2_Template_th_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.selectAllClicked($event); });
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tr_14_th_2_i_2_Template, 1, 4, "i", 13);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("width", ctx_r12.selectHelper.selectConfig.width, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.selectHelper.isMultiSelect());
} }
function EntityListComponent_tr_14_ng_container_4_th_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\n                                        ");
    ɵngcc0.ɵɵelement(2, "i", 17);
    ɵngcc0.ɵɵtext(3, "\n                                        ");
    ɵngcc0.ɵɵelement(4, "i", 18);
    ɵngcc0.ɵɵtext(5, "\n                                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r18 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("opacity", column_r18.sort.direction === ctx_r20.sortEnum.Asc ? null : 0.4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("opacity", column_r18.sort.direction === ctx_r20.sortEnum.Desc ? null : 0.4);
} }
const _c0 = function (a0) { return { cursor: a0 }; };
function EntityListComponent_tr_14_ng_container_4_th_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 16);
    ɵngcc0.ɵɵlistener("click", function EntityListComponent_tr_14_ng_container_4_th_2_Template_th_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const column_r18 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.columnSorted(column_r18, $event); });
    ɵngcc0.ɵɵtext(1, "\n                                ");
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, EntityListComponent_tr_14_ng_container_4_th_2_span_4_Template, 6, 4, "span", 4);
    ɵngcc0.ɵɵtext(5, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵstyleProp("width", column_r18.style ? column_r18.style.width : null, "px");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c0, column_r18.sort.disableSort ? "auto" : "pointer"))("ngClass", column_r18.hasColumnClass ? column_r18.getColumnClass(null) : null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", column_r18.name, "\n                                    ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r18.sort && !column_r18.sort.disableSort);
} }
function EntityListComponent_tr_14_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tr_14_ng_container_4_th_2_Template, 7, 8, "th", 15);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r18 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r18.showColumn(ctx_r13.printMode));
} }
function EntityListComponent_tr_14_th_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("width", ctx_r14.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.entityListConfigDelete.headerText);
} }
function EntityListComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tr_14_th_2_Template, 4, 3, "th", 9);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵtemplate(4, EntityListComponent_tr_14_ng_container_4_Template, 4, 1, "ng-container", 10);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵtemplate(6, EntityListComponent_tr_14_th_6_Template, 5, 3, "th", 11);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.selectHelper.showSelect(ctx_r2.printMode));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.columns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showDelete());
} }
function EntityListComponent_tr_16_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " ");
} }
function EntityListComponent_tr_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 19);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tr_16_ng_template_2_Template, 1, 0, "ng-template", 20);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.headerTemplate);
} }
function EntityListComponent_tbody_19_tr_2_td_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const entity_r28 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r34 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("fa-check-square-o", ctx_r34.selectHelper.isItemSelected(entity_r28))("fa-square-o", !ctx_r34.selectHelper.isItemSelected(entity_r28));
} }
function EntityListComponent_tbody_19_tr_2_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 26);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_19_tr_2_td_2_i_2_Template, 1, 4, "i", 13);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r29.selectHelper.isItemSelected(entity_r28) ? ctx_r29.selectHelper.selectConfig.selectedColor : null)("width", ctx_r29.selectHelper.selectConfig.width, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.selectHelper.isSelectable(entity_r28));
} }
function EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 32);
} if (rf & 2) {
    const column_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r40 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", column_r37.getItemValue(entity_r28, ctx_r40.entityListPipeService), ɵngcc0.ɵɵsanitizeHtml);
} }
function EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 33);
    ɵngcc0.ɵɵlistener("click", function EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_a_4_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r47); const column_r37 = ɵngcc0.ɵɵnextContext(2).$implicit; const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r45 = ɵngcc0.ɵɵnextContext(2); return ctx_r45.handleLinkFunction(entity_r28, column_r37, $event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r41 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(column_r37.getItemValue(entity_r28, ctx_r41.entityListPipeService));
} }
function EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r42 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                                    ", column_r37.getItemValue(entity_r28, ctx_r42.entityListPipeService), "\n                                ");
} }
function EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r55 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 29);
    ɵngcc0.ɵɵlistener("click", function EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_Template_td_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r55); const column_r37 = ɵngcc0.ɵɵnextContext().$implicit; const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r53 = ɵngcc0.ɵɵnextContext(2); return column_r37.fireOnColumnSelected ? ctx_r53.columnSelected(entity_r28, column_r37, $event) : null; });
    ɵngcc0.ɵɵtext(1, "\n                                ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_div_2_Template, 1, 1, "div", 30);
    ɵngcc0.ɵɵtext(3, "\n                                ");
    ɵngcc0.ɵɵtemplate(4, EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_a_4_Template, 2, 1, "a", 31);
    ɵngcc0.ɵɵtext(5, "\n                                ");
    ɵngcc0.ɵɵtemplate(6, EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_div_6_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtext(7, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r38.selectHelper.isItemSelected(entity_r28) ? ctx_r38.selectHelper.selectConfig.selectedColor : null)("width", column_r37.style ? column_r37.style.width : null, "px");
    ɵngcc0.ɵɵproperty("ngClass", column_r37.hasColumnClass ? column_r37.getColumnClass(entity_r28) : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r37.bindToInnerHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r37.linkFunction);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !column_r37.bindToInnerHtml && !column_r37.linkFunction);
} }
function EntityListComponent_tbody_19_tr_2_ng_container_4_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 34);
    ɵngcc0.ɵɵtext(1, "\n                                ");
    ɵngcc0.ɵɵelementContainerStart(2, 35);
    ɵngcc0.ɵɵtext(3, "\n                                ");
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtext(4, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r39 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r39.selectHelper.isItemSelected(entity_r28) ? ctx_r39.selectHelper.selectConfig.selectedColor : null)("width", column_r37.style ? column_r37.style.width : null, "px");
    ɵngcc0.ɵɵproperty("ngClass", column_r37.hasColumnClass ? column_r37.getColumnClass(entity_r28) : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("componentRef", column_r37.component)("item", entity_r28)("entityListComponentMembers", ctx_r39.entityListComponentMembers);
} }
function EntityListComponent_tbody_19_tr_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_19_tr_2_ng_container_4_td_2_Template, 8, 8, "td", 27);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵtemplate(4, EntityListComponent_tbody_19_tr_2_ng_container_4_td_4_Template, 5, 8, "td", 28);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r37 = ctx.$implicit;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r37.showColumn(ctx_r30.printMode) && !column_r37.component);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r37.showColumn(ctx_r30.printMode) && column_r37.component);
} }
function EntityListComponent_tbody_19_tr_2_td_6_Template(rf, ctx) { if (rf & 1) {
    const _r63 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 36);
    ɵngcc0.ɵɵlistener("mtConfirm", function EntityListComponent_tbody_19_tr_2_td_6_Template_td_mtConfirm_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r63); const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r61 = ɵngcc0.ɵɵnextContext(2); return ctx_r61.itemDeleted(entity_r28, $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r31 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r31.selectHelper.isItemSelected(entity_r28) ? ctx_r31.selectHelper.selectConfig.selectedColor : null)("width", ctx_r31.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵproperty("mtConfirmOptions", ctx_r31.entityListConfigDelete.getConfirm(entity_r28))("innerHtml", ctx_r31.entityListConfigDelete.getColumnHtml(entity_r28), ɵngcc0.ɵɵsanitizeHtml);
} }
function EntityListComponent_tbody_19_tr_2_td_8_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 37);
    ɵngcc0.ɵɵlistener("click", function EntityListComponent_tbody_19_tr_2_td_8_Template_td_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r67); const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r65 = ɵngcc0.ɵɵnextContext(2); return ctx_r65.itemDeleted(entity_r28, $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r32 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r32.selectHelper.isItemSelected(entity_r28) ? ctx_r32.selectHelper.selectConfig.selectedColor : null)("width", ctx_r32.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r32.entityListConfigDelete.getColumnHtml(entity_r28), ɵngcc0.ɵɵsanitizeHtml);
} }
function EntityListComponent_tbody_19_tr_2_td_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 26);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelementContainerStart(2, 35);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtext(4, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r33 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r33.selectHelper.isItemSelected(entity_r28) ? ctx_r33.selectHelper.selectConfig.selectedColor : null)("width", ctx_r33.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("componentRef", ctx_r33.entityListConfigDelete.component)("item", entity_r28)("entityListComponentMembers", ctx_r33.entityListComponentMembers);
} }
function EntityListComponent_tbody_19_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r71 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 22);
    ɵngcc0.ɵɵlistener("click", function EntityListComponent_tbody_19_tr_2_Template_tr_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r71); const entity_r28 = ctx.$implicit; const ctx_r70 = ɵngcc0.ɵɵnextContext(2); return ctx_r70.itemSelected(entity_r28, $event); });
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_19_tr_2_td_2_Template, 4, 5, "td", 23);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵtemplate(4, EntityListComponent_tbody_19_tr_2_ng_container_4_Template, 6, 2, "ng-container", 10);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵtemplate(6, EntityListComponent_tbody_19_tr_2_td_6_Template, 1, 6, "td", 24);
    ɵngcc0.ɵɵtext(7, "\n                        ");
    ɵngcc0.ɵɵtemplate(8, EntityListComponent_tbody_19_tr_2_td_8_Template, 1, 5, "td", 25);
    ɵngcc0.ɵɵtext(9, "\n                        ");
    ɵngcc0.ɵɵtemplate(10, EntityListComponent_tbody_19_tr_2_td_10_Template, 5, 7, "td", 23);
    ɵngcc0.ɵɵtext(11, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r28 = ctx.$implicit;
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r27.entityListConfig.hasRowClass ? ctx_r27.entityListConfig.getRowClass(entity_r28) : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.selectHelper.showSelect(ctx_r27.printMode));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r27.columns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.showDelete() && ctx_r27.entityListConfigDelete.confirm && !ctx_r27.entityListConfigDelete.component);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.showDelete() && !ctx_r27.entityListConfigDelete.confirm && !ctx_r27.entityListConfigDelete.component);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.showDelete() && ctx_r27.entityListConfigDelete.component);
} }
function EntityListComponent_tbody_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_19_tr_2_Template, 12, 6, "tr", 21);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.entities);
} }
function EntityListComponent_tbody_21_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " ");
} }
const _c1 = function (a0) { return { $implicit: a0 }; };
function EntityListComponent_tbody_21_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_21_ng_container_2_ng_template_2_Template, 1, 0, "ng-template", 38);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const entity_r73 = ctx.$implicit;
    const ctx_r72 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r72.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, entity_r73));
} }
function EntityListComponent_tbody_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵtemplate(2, EntityListComponent_tbody_21_ng_container_2_Template, 4, 4, "ng-container", 10);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.entities);
} }
function EntityListComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r76 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "entity-list-pagination", 39);
    ɵngcc0.ɵɵlistener("currentPageChange", function EntityListComponent_div_25_Template_entity_list_pagination_currentPageChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r75 = ɵngcc0.ɵɵnextContext(); return ctx_r75.currentPage = $event; })("pageChange", function EntityListComponent_div_25_Template_entity_list_pagination_pageChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r77 = ɵngcc0.ɵɵnextContext(); return ctx_r77.getEntities(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("total", ctx_r6.total)("currentPage", ctx_r6.currentPage)("itemsPerPage", ctx_r6.itemsPerPage);
} }
function EntityListComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "span", 40);
    ɵngcc0.ɵɵelementStart(3, "em");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "number");
    ɵngcc0.ɵɵpipe(6, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2("limiting results to first ", ɵngcc0.ɵɵpipeBind1(5, 2, ctx_r7.itemsPerPage), " of ", ɵngcc0.ɵɵpipeBind1(6, 4, ctx_r7.total), "");
} }
function EntityListComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "span", 41);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.getItemCounts());
} }
function EntityListComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h3", 42);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.emptyMessage);
} }
const _c2 = ["*"];
function EntityListPrintComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "button", 3);
    ɵngcc0.ɵɵlistener("click", function EntityListPrintComponent_div_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.togglePrintMode(); });
    ɵngcc0.ɵɵtext(3, "Close Print View");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} }
function EntityListPrintComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "button", 5);
    ɵngcc0.ɵɵlistener("click", function EntityListPrintComponent_span_3_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.togglePrintMode(); });
    ɵngcc0.ɵɵelement(3, "i", 6);
    ɵngcc0.ɵɵtext(4, " Print");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} }
function VirtualScrollEntityListComponent_tr_9_th_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 12);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("fa-check-square-o", ctx_r9.selectHelper.isAllItemsSelected(ctx_r9.entities))("fa-square-o", !ctx_r9.selectHelper.isAllItemsSelected(ctx_r9.entities));
} }
function VirtualScrollEntityListComponent_tr_9_th_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 10);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tr_9_th_2_Template_th_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.selectAllClicked($event); });
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tr_9_th_2_i_2_Template, 1, 4, "i", 11);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("width", ctx_r6.selectHelper.selectConfig.width, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.selectHelper.isMultiSelect());
} }
function VirtualScrollEntityListComponent_tr_9_ng_container_4_th_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\n                                        ");
    ɵngcc0.ɵɵelement(2, "i", 15);
    ɵngcc0.ɵɵtext(3, "\n                                        ");
    ɵngcc0.ɵɵelement(4, "i", 16);
    ɵngcc0.ɵɵtext(5, "\n                                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r12 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("opacity", column_r12.sort.direction === ctx_r14.sortEnum.Asc ? null : 0.4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("opacity", column_r12.sort.direction === ctx_r14.sortEnum.Desc ? null : 0.4);
} }
function VirtualScrollEntityListComponent_tr_9_ng_container_4_th_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 14);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tr_9_ng_container_4_th_2_Template_th_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const column_r12 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.columnSorted(column_r12, $event); });
    ɵngcc0.ɵɵtext(1, "\n                                ");
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, VirtualScrollEntityListComponent_tr_9_ng_container_4_th_2_span_4_Template, 6, 4, "span", 3);
    ɵngcc0.ɵɵtext(5, "\n                                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵstyleProp("width", column_r12.style ? column_r12.style.width : null, "px");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c0, column_r12.sort.disableSort ? "auto" : "pointer"))("ngClass", column_r12.hasColumnClass ? column_r12.getColumnClass(null) : null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", column_r12.name, "\n                                    ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r12.sort && !column_r12.sort.disableSort);
} }
function VirtualScrollEntityListComponent_tr_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tr_9_ng_container_4_th_2_Template, 7, 8, "th", 13);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r12 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r12.showColumn(ctx_r7.printMode));
} }
function VirtualScrollEntityListComponent_tr_9_th_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("width", ctx_r8.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.entityListConfigDelete.headerText);
} }
function VirtualScrollEntityListComponent_tr_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tr_9_th_2_Template, 4, 3, "th", 7);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵtemplate(4, VirtualScrollEntityListComponent_tr_9_ng_container_4_Template, 4, 1, "ng-container", 8);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵtemplate(6, VirtualScrollEntityListComponent_tr_9_th_6_Template, 5, 3, "th", 9);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectHelper.showSelect(ctx_r0.printMode));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.columns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showDelete());
} }
function VirtualScrollEntityListComponent_tr_11_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " ");
} }
function VirtualScrollEntityListComponent_tr_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 17);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tr_11_ng_template_2_Template, 1, 0, "ng-template", 18);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
} }
function VirtualScrollEntityListComponent_tr_13_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 22);
    ɵngcc0.ɵɵelementStart(1, "a", 23);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tr_13_span_7_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.scrollToTop(); });
    ɵngcc0.ɵɵelement(2, "i", 24);
    ɵngcc0.ɵɵtext(3, " back to top");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function VirtualScrollEntityListComponent_tr_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 19);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵelementStart(2, "th", 20);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                            ");
    ɵngcc0.ɵɵtemplate(7, VirtualScrollEntityListComponent_tr_13_span_7_Template, 4, 0, "span", 21);
    ɵngcc0.ɵɵtext(8, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.formattedTotal());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isScrolledDown && ctx_r2.stickyHeaderConfig);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_td_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 12);
} if (rf & 2) {
    const entity_r25 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r31 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("fa-check-square-o", ctx_r31.selectHelper.isItemSelected(entity_r25))("fa-square-o", !ctx_r31.selectHelper.isItemSelected(entity_r25));
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 30);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_16_tr_2_td_2_i_2_Template, 1, 4, "i", 11);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r26.selectHelper.isItemSelected(entity_r25) ? ctx_r26.selectHelper.selectConfig.selectedColor : null)("width", ctx_r26.selectHelper.selectConfig.width, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.selectHelper.isSelectable(entity_r25));
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 36);
} if (rf & 2) {
    const column_r34 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r37 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", column_r34.getItemValue(entity_r25, ctx_r37.entityListPipeService), ɵngcc0.ɵɵsanitizeHtml);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 37);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_a_4_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r44); const column_r34 = ɵngcc0.ɵɵnextContext(2).$implicit; const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r42 = ɵngcc0.ɵɵnextContext(2); return ctx_r42.handleLinkFunction(entity_r25, column_r34, $event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(column_r34.getItemValue(entity_r25, ctx_r38.entityListPipeService));
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r39 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                                    ", column_r34.getItemValue(entity_r25, ctx_r39.entityListPipeService), "\n                                ");
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r52 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 33);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_Template_td_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r52); const column_r34 = ɵngcc0.ɵɵnextContext().$implicit; const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r50 = ɵngcc0.ɵɵnextContext(2); return column_r34.fireOnColumnSelected ? ctx_r50.columnSelected(entity_r25, column_r34, $event) : null; });
    ɵngcc0.ɵɵtext(1, "\n                                ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_div_2_Template, 1, 1, "div", 34);
    ɵngcc0.ɵɵtext(3, "\n                                ");
    ɵngcc0.ɵɵtemplate(4, VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_a_4_Template, 2, 1, "a", 35);
    ɵngcc0.ɵɵtext(5, "\n                                ");
    ɵngcc0.ɵɵtemplate(6, VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_div_6_Template, 2, 1, "div", 3);
    ɵngcc0.ɵɵtext(7, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = ɵngcc0.ɵɵnextContext().$implicit;
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r35 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r35.selectHelper.isItemSelected(entity_r25) ? ctx_r35.selectHelper.selectConfig.selectedColor : null)("width", column_r34.style ? column_r34.style.width : null, "px");
    ɵngcc0.ɵɵproperty("ngClass", column_r34.hasColumnClass ? column_r34.getColumnClass(entity_r25) : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r34.bindToInnerHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r34.linkFunction);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !column_r34.bindToInnerHtml && !column_r34.linkFunction);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 38);
    ɵngcc0.ɵɵtext(1, "\n                                ");
    ɵngcc0.ɵɵelementContainerStart(2, 39);
    ɵngcc0.ɵɵtext(3, "\n                                ");
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtext(4, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = ɵngcc0.ɵɵnextContext().$implicit;
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r36 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r36.selectHelper.isItemSelected(entity_r25) ? ctx_r36.selectHelper.selectConfig.selectedColor : null)("width", column_r34.style ? column_r34.style.width : null, "px");
    ɵngcc0.ɵɵproperty("ngClass", column_r34.hasColumnClass ? column_r34.getColumnClass(entity_r25) : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("componentRef", column_r34.component)("item", entity_r25)("entityListComponentMembers", ctx_r36.entityListComponentMembers);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_2_Template, 8, 8, "td", 31);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵtemplate(4, VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_td_4_Template, 5, 8, "td", 32);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r34 = ctx.$implicit;
    const ctx_r27 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r34.showColumn(ctx_r27.printMode) && !column_r34.component);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r34.showColumn(ctx_r27.printMode) && column_r34.component);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_td_6_Template(rf, ctx) { if (rf & 1) {
    const _r60 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 40);
    ɵngcc0.ɵɵlistener("mtConfirm", function VirtualScrollEntityListComponent_tbody_16_tr_2_td_6_Template_td_mtConfirm_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r58 = ɵngcc0.ɵɵnextContext(2); return ctx_r58.itemDeleted(entity_r25, $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r28.selectHelper.isItemSelected(entity_r25) ? ctx_r28.selectHelper.selectConfig.selectedColor : null)("width", ctx_r28.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵproperty("mtConfirmOptions", ctx_r28.entityListConfigDelete.getConfirm(entity_r25))("innerHtml", ctx_r28.entityListConfigDelete.getColumnHtml(entity_r25), ɵngcc0.ɵɵsanitizeHtml);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_td_8_Template(rf, ctx) { if (rf & 1) {
    const _r64 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 41);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tbody_16_tr_2_td_8_Template_td_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r64); const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r62 = ɵngcc0.ɵɵnextContext(2); return ctx_r62.itemDeleted(entity_r25, $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r29.selectHelper.isItemSelected(entity_r25) ? ctx_r29.selectHelper.selectConfig.selectedColor : null)("width", ctx_r29.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r29.entityListConfigDelete.getColumnHtml(entity_r25), ɵngcc0.ɵɵsanitizeHtml);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_td_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 30);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelementContainerStart(2, 39);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtext(4, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r30.selectHelper.isItemSelected(entity_r25) ? ctx_r30.selectHelper.selectConfig.selectedColor : null)("width", ctx_r30.entityListConfigDelete.width, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("componentRef", ctx_r30.entityListConfigDelete.component)("item", entity_r25)("entityListComponentMembers", ctx_r30.entityListComponentMembers);
} }
function VirtualScrollEntityListComponent_tbody_16_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r68 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 26);
    ɵngcc0.ɵɵlistener("click", function VirtualScrollEntityListComponent_tbody_16_tr_2_Template_tr_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r68); const entity_r25 = ctx.$implicit; const ctx_r67 = ɵngcc0.ɵɵnextContext(2); return ctx_r67.itemSelected(entity_r25, $event); });
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_16_tr_2_td_2_Template, 4, 5, "td", 27);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵtemplate(4, VirtualScrollEntityListComponent_tbody_16_tr_2_ng_container_4_Template, 6, 2, "ng-container", 8);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵtemplate(6, VirtualScrollEntityListComponent_tbody_16_tr_2_td_6_Template, 1, 6, "td", 28);
    ɵngcc0.ɵɵtext(7, "\n                        ");
    ɵngcc0.ɵɵtemplate(8, VirtualScrollEntityListComponent_tbody_16_tr_2_td_8_Template, 1, 5, "td", 29);
    ɵngcc0.ɵɵtext(9, "\n                        ");
    ɵngcc0.ɵɵtemplate(10, VirtualScrollEntityListComponent_tbody_16_tr_2_td_10_Template, 5, 7, "td", 27);
    ɵngcc0.ɵɵtext(11, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r25 = ctx.$implicit;
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r24.entityListConfig.hasRowClass ? ctx_r24.entityListConfig.getRowClass(entity_r25) : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.selectHelper.showSelect(ctx_r24.printMode));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r24.columns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.showDelete() && ctx_r24.entityListConfigDelete.confirm && !ctx_r24.entityListConfigDelete.component);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.showDelete() && !ctx_r24.entityListConfigDelete.confirm && !ctx_r24.entityListConfigDelete.component);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.showDelete() && ctx_r24.entityListConfigDelete.component);
} }
function VirtualScrollEntityListComponent_tbody_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_16_tr_2_Template, 12, 6, "tr", 25);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.entities);
} }
function VirtualScrollEntityListComponent_tbody_18_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " ");
} }
function VirtualScrollEntityListComponent_tbody_18_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_18_ng_container_2_ng_template_2_Template, 1, 0, "ng-template", 42);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const entity_r70 = ctx.$implicit;
    const ctx_r69 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r69.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, entity_r70));
} }
function VirtualScrollEntityListComponent_tbody_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵtemplate(2, VirtualScrollEntityListComponent_tbody_18_ng_container_2_Template, 4, 4, "ng-container", 8);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.entities);
} }
function VirtualScrollEntityListComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h3", 43);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.emptyMessage);
} }
class EntityListItemDirective {
}
EntityListItemDirective.ɵfac = function EntityListItemDirective_Factory(t) { return new (t || EntityListItemDirective)(); };
EntityListItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EntityListItemDirective, selectors: [["", "entityListItem", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListItemDirective, [{
        type: Directive,
        args: [{
                selector: '[entityListItem]'
            }]
    }], null, null); })();

class EntityListHeaderDirective {
}
EntityListHeaderDirective.ɵfac = function EntityListHeaderDirective_Factory(t) { return new (t || EntityListHeaderDirective)(); };
EntityListHeaderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EntityListHeaderDirective, selectors: [["", "entityListHeader", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListHeaderDirective, [{
        type: Directive,
        args: [{
                selector: '[entityListHeader]'
            }]
    }], null, null); })();

class AddressPipe {
    constructor() { }
    transform(value, args) {
        var _a;
        let addr = (_a = value === null || value === void 0 ? void 0 : value.Address) !== null && _a !== void 0 ? _a : '';
        if (addr) {
            addr = format.address(addr);
        }
        return addr;
    }
}
AddressPipe.ɵfac = function AddressPipe_Factory(t) { return new (t || AddressPipe)(); };
AddressPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "address", type: AddressPipe, pure: true });
AddressPipe.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AddressPipe, [{
        type: Pipe,
        args: [{
                name: 'address'
            }]
    }], function () { return []; }, null); })();

class EntityListPipeService {
    constructor(primaryPipe, phonePipe, addressPipe, datePipe, upperCasePipe, lowerCasePipe, numberPipe, currencyPipe, percentPipe) {
        this.primaryPipe = primaryPipe;
        this.phonePipe = phonePipe;
        this.addressPipe = addressPipe;
        this.datePipe = datePipe;
        this.upperCasePipe = upperCasePipe;
        this.lowerCasePipe = lowerCasePipe;
        this.numberPipe = numberPipe;
        this.currencyPipe = currencyPipe;
        this.percentPipe = percentPipe;
    }
    /**
     * transforms the value using the indicated pipe
     * @param value
     * @param pipe
     */
    applyPipe(value, pipe) {
        let pipeValues = pipe.split(':').map((p) => p.replace(/^\'+|\'+$/g, ''));
        if (pipeValues[0] === 'primary') {
            return this.primaryPipe.transform(value);
        }
        if (pipeValues[0] === 'phone') {
            return this.phonePipe.transform(value);
        }
        if (pipeValues[0] === 'address') {
            return this.addressPipe.transform(value);
        }
        if (pipeValues[0] === 'date') {
            return this.datePipe.transform(value, pipeValues[1], pipeValues[2], pipeValues[3]);
        }
        if (pipeValues[0] === 'upper') {
            return this.upperCasePipe.transform(value);
        }
        if (pipeValues[0] === 'lower') {
            return this.lowerCasePipe.transform(value);
        }
        if (pipeValues[0] === 'number') {
            return this.numberPipe.transform(value, pipeValues[1], pipeValues[2]);
        }
        if (pipeValues[0] === 'currency') {
            return this.currencyPipe.transform(value, pipeValues[1], pipeValues[2], pipeValues[3], pipeValues[4]);
        }
        if (pipeValues[0] === 'percent') {
            return this.percentPipe.transform(value, pipeValues[1], pipeValues[2]);
        }
    }
}
EntityListPipeService.ɵfac = function EntityListPipeService_Factory(t) { return new (t || EntityListPipeService)(ɵngcc0.ɵɵinject(ɵngcc1.IsPrimaryPipe), ɵngcc0.ɵɵinject(ɵngcc1.PhonePipe), ɵngcc0.ɵɵinject(AddressPipe), ɵngcc0.ɵɵinject(ɵngcc2.DatePipe), ɵngcc0.ɵɵinject(ɵngcc2.UpperCasePipe), ɵngcc0.ɵɵinject(ɵngcc2.LowerCasePipe), ɵngcc0.ɵɵinject(ɵngcc2.DecimalPipe), ɵngcc0.ɵɵinject(ɵngcc2.CurrencyPipe), ɵngcc0.ɵɵinject(ɵngcc2.PercentPipe)); };
EntityListPipeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EntityListPipeService, factory: EntityListPipeService.ɵfac });
EntityListPipeService.ctorParameters = () => [
    { type: IsPrimaryPipe },
    { type: PhonePipe },
    { type: AddressPipe },
    { type: DatePipe },
    { type: UpperCasePipe },
    { type: LowerCasePipe },
    { type: DecimalPipe },
    { type: CurrencyPipe },
    { type: PercentPipe }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListPipeService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.IsPrimaryPipe }, { type: ɵngcc1.PhonePipe }, { type: AddressPipe }, { type: ɵngcc2.DatePipe }, { type: ɵngcc2.UpperCasePipe }, { type: ɵngcc2.LowerCasePipe }, { type: ɵngcc2.DecimalPipe }, { type: ɵngcc2.CurrencyPipe }, { type: ɵngcc2.PercentPipe }]; }, null); })();

var ColumnShowOnPrint;
(function (ColumnShowOnPrint) {
    ColumnShowOnPrint[ColumnShowOnPrint["ShowAlways"] = 0] = "ShowAlways";
    ColumnShowOnPrint[ColumnShowOnPrint["HideOnPrint"] = 1] = "HideOnPrint";
    ColumnShowOnPrint[ColumnShowOnPrint["ShowOnlyOnPrint"] = 2] = "ShowOnlyOnPrint";
})(ColumnShowOnPrint || (ColumnShowOnPrint = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
class EntityListColumn {
    constructor(column) {
        this.name = column.name;
        this.accessors = column.accessors;
        this.accessorFunction = column.accessorFunction;
        this.pipes = column.pipes;
        this.bindToInnerHtml = column.bindToInnerHtml;
        this.linkFunction = column.linkFunction;
        this.fireOnColumnSelected = column.fireOnColumnSelected;
        this.style = column.style;
        this.showOnPrint = column.showOnPrint;
        if (column.sort) {
            column.sort.direction = column.sort.defaultDirection ? column.sort.defaultDirection : null;
            column.sort.sortProperty = column.sort.sortProperty ? column.sort.sortProperty : this.getSortProperty(column);
            column.sort.disableSort = column.sort.disableSort ? column.sort.disableSort : false;
            column.sort.isDefaultForSort = column.sort.isDefaultForSort;
        }
        else {
            column.sort = {
                isDefaultForSort: false,
                sortProperty: this.getSortProperty(column),
            };
        }
        this.sort = column.sort;
        this.component = column.component;
        this.columnClass = column.columnClass;
        this.excludeFromExport = column.excludeFromExport;
        this.excludeFromView = column.excludeFromView;
    }
    get hasColumnClass() {
        return this.columnClass ? true : false;
    }
    getColumnClass(entity) {
        // return null if it's a header because that will never have an entity
        if (!entity) {
            return null;
        }
        if (typeof this.columnClass === 'function') {
            return this.columnClass(entity);
        }
        else {
            return this.columnClass;
        }
    }
    showColumn(printMode) {
        let show = true;
        const showOnPrint = this.showOnPrint;
        if (showOnPrint === null || showOnPrint === undefined) {
            return show;
        }
        if (printMode) {
            show = showOnPrint === ColumnShowOnPrint.ShowAlways || showOnPrint === ColumnShowOnPrint.ShowOnlyOnPrint;
        }
        else {
            show = showOnPrint === ColumnShowOnPrint.ShowAlways || showOnPrint === ColumnShowOnPrint.HideOnPrint;
        }
        return show;
    }
    getItemValue(entity, entityListPipeService) {
        let column = this;
        let value = entity;
        if (column.accessors) {
            column.accessors.forEach((accessor) => {
                value = value[accessor];
            });
        }
        else if (column.accessorFunction) {
            value = column.accessorFunction(entity);
        }
        else {
            value = value[column.name];
        }
        if (column.pipes) {
            column.pipes.forEach((pipe) => {
                value = entityListPipeService.applyPipe(value, pipe);
            });
        }
        return value;
    }
    getSortProperty(column) {
        return column.accessors ? column.accessors.join('.') : column.name;
    }
}

function instanceOfIEntityListDeleteColumn(object) {
    if (typeof object !== 'object') {
        return false;
    }
    return ('confirm' in object ||
        'headerText' in object ||
        'columnHtml' in object ||
        'showOnPrint' in object ||
        'width' in object ||
        'component' in object);
}
/**
 * defines a delete column for the EntityListComponent
 * @param confirm perform a confirm within the entity list component
 * @param width how wide to make the column
 */
class EntityListDeleteColumn {
    constructor(confirm, width, showOnPrint) {
        this.errorHandler = new ComponentErrorHandler('EntityListDeleteColumn', '@mt-ng2/entity-list-module');
        this.deprecatedConstructorParamsCheck(width, showOnPrint);
        const constructorParams = instanceOfIEntityListDeleteColumn(confirm)
            ? confirm
            : {
                confirm: confirm,
                showOnPrint: showOnPrint,
                width: width,
            };
        if (typeof constructorParams.confirm === 'undefined' || constructorParams.confirm === true) {
            this.confirm = {};
        }
        else if (constructorParams.confirm !== false) {
            this.confirm = constructorParams.confirm;
        }
        else {
            this.confirm = null;
        }
        this.width = typeof constructorParams.width !== 'undefined' ? constructorParams.width : 50;
        this.showOnPrint = typeof constructorParams.showOnPrint !== 'undefined' ? constructorParams.showOnPrint : ColumnShowOnPrint.HideOnPrint;
        this.headerText = typeof constructorParams.headerText !== 'undefined' ? constructorParams.headerText : 'Delete';
        this.columnHtml =
            typeof constructorParams.columnHtml !== 'undefined'
                ? constructorParams.columnHtml
                : '<i class="fa fa-2x fa-fw fa-trash icon-main" aria-hidden="true"></i>';
        this.component = typeof constructorParams.component !== 'undefined' ? constructorParams.component : null;
    }
    deprecatedConstructorParamsCheck(width, showOnPrint) {
        if (typeof width !== 'undefined') {
            this.errorHandler.addWarning('width constructor parameter deprecated August-2018 with release 2.1.1 - use IEntityListDeleteColumn as your first parameter instead');
        }
        if (typeof showOnPrint !== 'undefined') {
            this.errorHandler.addWarning('showOnPrint constructor parameter deprecated August-2018 with release 2.1.1 - use IEntityListDeleteColumn as your first parameter instead');
        }
    }
    getColumnHtml(entity) {
        if (typeof this.columnHtml === 'function') {
            return this.columnHtml(entity);
        }
        else {
            return this.columnHtml;
        }
    }
    getConfirm(entity) {
        if (typeof this.confirm === 'function') {
            return this.confirm(entity);
        }
        else {
            return this.confirm;
        }
    }
    showColumn(printMode) {
        let show = true;
        const showOnPrint = this.showOnPrint;
        if (showOnPrint === null || showOnPrint === undefined) {
            return show;
        }
        if (printMode) {
            show = showOnPrint === ColumnShowOnPrint.ShowAlways || showOnPrint === ColumnShowOnPrint.ShowOnlyOnPrint;
        }
        else {
            show = showOnPrint === ColumnShowOnPrint.ShowAlways || showOnPrint === ColumnShowOnPrint.HideOnPrint;
        }
        return show;
    }
}

var SelectTypes;
(function (SelectTypes) {
    SelectTypes[SelectTypes["Single"] = 1] = "Single";
    SelectTypes[SelectTypes["Multi"] = 2] = "Multi";
})(SelectTypes || (SelectTypes = {}));
function instanceOfIEntityListSelectColumn(object) {
    if (!object || typeof object !== 'object') {
        return false;
    }
    return ('type' in object ||
        'width' in object ||
        'selectedColor' in object ||
        'uniqueId' in object ||
        'showOnPrint' in object ||
        'selectable' in object);
}
/**
 * class to be used in the EntityListComponent to define a select column
 */
class EntityListSelectColumn {
    /**
     * Deprecation Message: "non interface constructor parameters deprecated January-2021 with release 5.1.0 use IEntityListSelectColumn as your first parameter instead"
     * @param type
     * @deprecated @param width
     * @deprecated @param selectedColor
     * @deprecated @param uniqueId
     * @deprecated @param showOnPrint
     * @deprecated @param selectable
     */
    constructor(type, width, selectedColor, uniqueId, showOnPrint, selectable) {
        this.errorHandler = new ComponentErrorHandler('EntityListSelectColumn', '@mt-ng2/entity-list-module');
        this.deprecatedConstructorParamsCheck(type);
        const constructorParams = instanceOfIEntityListSelectColumn(type)
            ? type
            : {
                selectable: selectable,
                selectedColor: selectedColor,
                showOnPrint: showOnPrint,
                type: type,
                uniqueId: uniqueId,
                width: width,
            };
        this.type = typeof constructorParams.type !== 'undefined' && constructorParams.type !== null ? constructorParams.type : SelectTypes.Single;
        this.width = typeof constructorParams.width !== 'undefined' && constructorParams.width !== null ? constructorParams.width : 40;
        this.selectedColor =
            typeof constructorParams.selectedColor !== 'undefined' && constructorParams.selectedColor !== null
                ? constructorParams.selectedColor
                : '#a2c6e5';
        this.uniqueId = typeof constructorParams.uniqueId !== 'undefined' && constructorParams.uniqueId !== null ? constructorParams.uniqueId : 'Id';
        this.showOnPrint =
            typeof constructorParams.showOnPrint !== 'undefined' && constructorParams.showOnPrint !== null
                ? constructorParams.showOnPrint
                : ColumnShowOnPrint.HideOnPrint;
        this.selectable = typeof constructorParams.selectable !== 'undefined' ? constructorParams.selectable : null;
    }
    deprecatedConstructorParamsCheck(type) {
        if (type !== undefined && !instanceOfIEntityListSelectColumn(type)) {
            this.errorHandler.addWarning('non interface constructor parameters deprecated January-2021 with release 5.1.0 - use IEntityListSelectColumn as your first parameter instead');
        }
    }
    showColumn(printMode) {
        let show = true;
        const showOnPrint = this.showOnPrint;
        if (showOnPrint === null || showOnPrint === undefined) {
            return show;
        }
        if (printMode) {
            show = showOnPrint === ColumnShowOnPrint.ShowAlways || showOnPrint === ColumnShowOnPrint.ShowOnlyOnPrint;
        }
        else {
            show = showOnPrint === ColumnShowOnPrint.ShowAlways || showOnPrint === ColumnShowOnPrint.HideOnPrint;
        }
        return show;
    }
}

/**
 * helper class used by the entity list component to handle the logic pertaining to selecting rows/entities.
 * It is responsible for
 * - answering questions about the select columns configuration
 * - maintaining the list of selected entities, including logic to update that list
 * - answering questions about what is selected such as "are all items on page currently selected"
 */
class EntityListSelectHelper {
    constructor(_entityListConfig, entityListModuleConfig, initialSelectedEntities, getEntities) {
        this._entityListConfig = _entityListConfig;
        this.getEntities = getEntities;
        if (initialSelectedEntities === null || initialSelectedEntities === void 0 ? void 0 : initialSelectedEntities.length) {
            this.selectedEntities = initialSelectedEntities;
        }
        if (this.selectConfig && !this.selectConfig.selectedColor && (entityListModuleConfig === null || entityListModuleConfig === void 0 ? void 0 : entityListModuleConfig.selectedColor)) {
            this.selectConfig.selectedColor = entityListModuleConfig === null || entityListModuleConfig === void 0 ? void 0 : entityListModuleConfig.selectedColor;
        }
    }
    get selectConfig() {
        if (this._selectConfig === undefined) {
            this._selectConfig = this._entityListConfig.select ? new EntityListSelectColumn(this._entityListConfig.select) : null;
        }
        return this._selectConfig;
    }
    set selectedEntities(value) {
        this._selectedEntities = value;
    }
    get selectedEntities() {
        if (!this._selectedEntities) {
            this._selectedEntities = [];
        }
        return this._selectedEntities;
    }
    // uniqueId is the property on the entity to use as the unique identifier
    get uniqueId() {
        var _a, _b;
        return (_b = (_a = this.selectConfig) === null || _a === void 0 ? void 0 : _a.uniqueId) !== null && _b !== void 0 ? _b : 'Id';
    }
    /**
     * is the select type Multi
     */
    isMultiSelect() {
        var _a;
        return ((_a = this.selectConfig) === null || _a === void 0 ? void 0 : _a.type) === SelectTypes.Multi;
    }
    /**
     * check if the entity passed in is currently in the selected entities array
     * @param entity
     */
    isItemSelected(entity) {
        return this.selectedEntities.find((item) => item[this.uniqueId] === entity[this.uniqueId]) ? true : false;
    }
    /**
     * check if the array of entities passed in are all currently in the selected entities array
     * @param entities
     */
    isAllItemsSelected(entities) {
        const selectedIds = this.selectedEntities.map((item) => item[this.uniqueId]);
        return entities.every((item) => !this.isSelectable(item) || selectedIds.some((id) => id === item[this.uniqueId]));
    }
    /**
     * should the select column be shown on screen
     * @param printMode
     */
    showSelect(printMode) {
        var _a, _b;
        return (_b = (_a = this.selectConfig) === null || _a === void 0 ? void 0 : _a.showColumn(printMode)) !== null && _b !== void 0 ? _b : false;
    }
    /**
     * should the entity passed in be selectable
     * @param entity
     */
    isSelectable(entity) {
        var _a, _b, _c;
        // if the selectConfig has been provided a selectable function callback, then uses it else just return true
        return (_c = (_b = (_a = this.selectConfig) === null || _a === void 0 ? void 0 : _a.selectable) === null || _b === void 0 ? void 0 : _b.call(_a, entity)) !== null && _c !== void 0 ? _c : true;
    }
    /**
     * handle a single entity being clicked
     * @param entity
     */
    handleSelection(entity, clickEvent) {
        const shiftKey = clickEvent.shiftKey;
        if (this.isMultiSelect && shiftKey) {
            this.selectionWithShiftKey(entity);
        }
        else {
            this.selectionWithoutShiftKey(entity);
        }
    }
    selectionWithShiftKey(entity) {
        const alreadySelected = this.isItemSelected(entity);
        if (alreadySelected) {
            this.removeItemFromSelected(entity);
        }
        else {
            if (this._lastSelectedEntity && this.getItemIndexInCurrentEntities(this._lastSelectedEntity) > -1) {
                const selectedRange = this.getSelectedRange(entity);
                this.selectedEntities = this.selectedEntities.concat(selectedRange.filter((item) => !this.isItemSelected(item) && this.isSelectable(item)));
            }
            else {
                this.selectedEntities.push(entity);
                this._lastSelectedEntity = entity;
            }
        }
    }
    getSelectedRange(entity) {
        const currentEntities = this.getEntities();
        const lastIndex = this.getItemIndexInCurrentEntities(this._lastSelectedEntity);
        const currentIndex = this.getItemIndexInCurrentEntities(entity);
        const startIndex = lastIndex > currentIndex ? currentIndex : lastIndex + 1;
        const nonInclusiveEndingIndex = lastIndex > currentIndex ? lastIndex : currentIndex + 1;
        const selectedRange = currentEntities.slice(startIndex, nonInclusiveEndingIndex);
        return selectedRange;
    }
    getItemIndexInCurrentEntities(entityToFind) {
        const currentEntities = this.getEntities();
        return currentEntities.findIndex((item) => item[this.uniqueId] === entityToFind[this.uniqueId]);
    }
    selectionWithoutShiftKey(entity) {
        var _a;
        const alreadySelected = this.isItemSelected(entity);
        const type = (_a = this.selectConfig) === null || _a === void 0 ? void 0 : _a.type;
        if (type === SelectTypes.Multi) {
            if (alreadySelected) {
                this.removeItemFromSelected(entity);
            }
            else {
                this.selectedEntities.push(entity);
                this._lastSelectedEntity = entity;
            }
        }
        if (type === SelectTypes.Single) {
            if (alreadySelected) {
                return;
            }
            else {
                this.selectedEntities = [entity];
            }
        }
    }
    /**
     * handle a select all being clicked
     * @param entities
     */
    handleSelectAll() {
        const entities = this.getEntities();
        const selectedIds = this.selectedEntities.map((item) => item[this.uniqueId]);
        if (this.isAllItemsSelected(entities)) {
            entities.forEach((item) => {
                if (selectedIds.some((id) => id === item[this.uniqueId])) {
                    this.removeItemFromSelected(item);
                }
            });
        }
        else {
            entities.forEach((item) => {
                if (this.isSelectable(item) && !selectedIds.some((id) => id === item[this.uniqueId])) {
                    this.selectedEntities.push(item);
                }
            });
        }
    }
    /**
     * remove a single entity from the selected entities array
     * @param entity
     */
    removeItemFromSelected(entity) {
        const index = this.selectedEntities.findIndex((item) => item[this.uniqueId] === entity[this.uniqueId]);
        if (index > -1) {
            this.selectedEntities.splice(index, 1);
        }
    }
}

function buildEntityListApi(component) {
    const api = {};
    const clearSelectedItems = () => {
        component.selectHelper.selectedEntities = [];
        component.cdr.detectChanges();
    };
    const getSelectedItems = () => {
        return JSON.parse(JSON.stringify(component.selectHelper.selectedEntities));
    };
    const setSelectedItems = (value) => {
        component.selectHelper.selectedEntities = value;
        component.cdr.detectChanges();
    };
    api.selectedItems = {
        clear: clearSelectedItems,
        get: getSelectedItems,
        set: setSelectedItems,
    };
    api.sorting = {
        set: component.setColumnSorting.bind(component),
    };
    return api;
}

class EntityListComponent {
    constructor(injector) {
        this.printMode = false;
        this.sortEnum = SortDirection;
        /**
         * message to be shown when the entity array is empty
         *
         * default: 'No data to display.'
         */
        this.emptyMessage = 'No data to display.';
        this.itemsPerPageChange = new EventEmitter();
        /**
         * whether to show the item counts along with paging
         */
        this.showItemCounts = false;
        this.currentPageChange = new EventEmitter();
        /**
         * event that is fired whenever the page has been changed
         */
        this.onPageChanged = new EventEmitter();
        /**
         * event that is fired whenever an item is selected
         */
        this.onItemSelected = new EventEmitter();
        /**
         * event that is fired whenever a column sort is clicked
         */
        this.onColumnSorted = new EventEmitter();
        /**
         * event that is fired whenever a column is selected, so long as fireOnColumnSelected is set for that column
         */
        this.onColumnSelected = new EventEmitter();
        /**
         * event that is fired whenever an item is deleted
         */
        this.onItemDeleted = new EventEmitter();
        /**
         * event that is fired whenever an item is selected
         */
        this.onSelectionChanged = new EventEmitter();
        /**
         * event that is fired when the control is ready
         */
        this.ready = new EventEmitter();
        this.showPagination = true;
        this.entityListPipeService = injector.get(EntityListPipeService);
        this.differs = injector.get(KeyValueDiffers);
        this.entityListModuleConfig = injector.get(EntityListModuleConfigToken, null);
        this.cdr = injector.get(ChangeDetectorRef);
    }
    get entityListComponentMembers() {
        return {
            columnSelected: this.columnSelected.bind(this),
            entityListConfig: this.entityListConfig,
            getEntities: this.getEntities.bind(this),
            itemDeleted: this.itemDeleted.bind(this),
        };
    }
    get hasPrint() {
        return this.entityListConfig.print ? true : false;
    }
    set entities(value) {
        this._entities = value;
    }
    get entities() {
        if (!this._entities) {
            this._entities = [];
        }
        return this._entities;
    }
    set selectedEntities(value) {
        var _a;
        if ((_a = this.selectHelper) === null || _a === void 0 ? void 0 : _a.selectedEntities) {
            this.selectHelper.selectedEntities = value;
        }
        else {
            // this covers when the value is set before ngOnInit has run
            this._initialSelectedEntities = value;
        }
    }
    get selectedEntities() {
        var _a, _b;
        return (_b = (_a = this.selectHelper) === null || _a === void 0 ? void 0 : _a.selectedEntities) !== null && _b !== void 0 ? _b : [];
    }
    set entityListConfig(value) {
        if (value) {
            this.setEntityListConfigDelete(value.delete);
        }
        this._entityListConfig = value;
        if (!this._entityListConfigDiffer && value) {
            this._entityListConfigDiffer = this.differs.find(value).create();
        }
        this.columns = this.entityListConfig.columns
            .filter((column) => !column.excludeFromView)
            .map((column) => {
            if (column instanceof EntityListColumn) {
                return column;
            }
            return new EntityListColumn(column);
        });
    }
    get entityListConfig() {
        return this._entityListConfig;
    }
    set itemsPerPage(value) {
        if (this._itemsPerPage !== value) {
            this._itemsPerPage = value;
            this.itemsPerPageChange.emit(value);
        }
    }
    get itemsPerPage() {
        return this._itemsPerPage;
    }
    ngDoCheck() {
        if (this._entityListConfigDiffer) {
            const changes = this._entityListConfigDiffer.diff(this._entityListConfig);
            if (changes) {
                changes.forEachChangedItem((record) => {
                    if (record.key === 'delete') {
                        this.setEntityListConfigDelete(record.currentValue);
                    }
                });
            }
        }
    }
    ngOnInit() {
        var _a, _b;
        // if an itemsPerPage value was not explicitly passed
        if (!this.itemsPerPage) {
            // then assign it
            this.itemsPerPage = (_b = (_a = this.entityListModuleConfig) === null || _a === void 0 ? void 0 : _a.itemsPerPage) !== null && _b !== void 0 ? _b : 12;
        }
        this._itemsPerPageInitial = this.itemsPerPage;
        // setup entity select helper
        this.selectHelper = new EntityListSelectHelper(this.entityListConfig, this.entityListModuleConfig, this._initialSelectedEntities, (() => this.entities).bind(this));
        // check if any column was configured to have the default sort if not
        // just set it to the first column
        if (!this.entityListConfig.columns.find((c) => c.sort.hasOwnProperty('direction') && c.sort.direction !== null)) {
            // Get the first column noted as a default sort column
            let col = this.entityListConfig.columns.find((c) => c.sort.hasOwnProperty('isDefaultForSort') && c.sort.isDefaultForSort === true);
            // If one is found we set the sort.direction.  This variable is what the list components uses to
            // know which arrow to activate.  If one is not found I pick the first column by defauld.
            // The only catch here is if they are using a accessor function on the first object.  If thats
            // the case then they need to pass in the sortProperty or the control will bomb out.
            col
                ? (this.entityListConfig.columns[this.entityListConfig.columns.indexOf(col)].sort.direction = SortDirection.Asc)
                : (this.entityListConfig.columns[0].sort.direction = SortDirection.Asc);
        }
        this.ready.emit(buildEntityListApi(this));
    }
    setEntityListConfigDelete(value) {
        if (value) {
            if (value instanceof EntityListDeleteColumn) {
                this.entityListConfigDelete = value;
            }
            else {
                this.entityListConfigDelete = new EntityListDeleteColumn(value);
            }
        }
        else {
            this.entityListConfigDelete = null;
        }
    }
    noEntities() {
        return !this.entities || this.entities.length === 0;
    }
    pagingNeeded() {
        return this.total > this.itemsPerPage;
    }
    getEntities() {
        this.currentPageChange.emit(this.currentPage);
        this.onPageChanged.emit();
    }
    selectAllClicked(event) {
        this.selectHelper.handleSelectAll();
        this.emitSelectionChangedEvent(event);
    }
    itemSelected(entity, event) {
        var _a;
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        if (this.selectHelper.selectConfig && this.selectHelper.isSelectable(entity)) {
            this.selectHelper.handleSelection(entity, event);
            this.emitSelectionChangedEvent(event);
        }
        let itemSelectedEvent = {
            $event: event,
            entity: entity,
        };
        this.onItemSelected.emit(itemSelectedEvent);
    }
    setColumnSorting(sortPropertyName, direction) {
        this.sortDirection = direction;
        for (let i = 0; i < this.entityListConfig.columns.length; i++) {
            const col = this.entityListConfig.columns[i];
            if (col.hasOwnProperty('sort')) {
                col.sort.direction = col.sort.sortProperty !== sortPropertyName ? null : this.sortDirection;
            }
        }
    }
    columnSorted(column, event) {
        var _a;
        if (column.sort.disableSort) {
            return;
        }
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        // Flip the sort control
        column.sort.direction = column.sort.direction === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
        this.setColumnSorting(column.sort.sortProperty, column.sort.direction);
        let columnSortedEvent = {
            $event: event,
            column: column,
        };
        this.onColumnSorted.emit(columnSortedEvent);
    }
    emitSelectionChangedEvent(event) {
        let selectionChangedEvent = {
            $event: event,
            selectedEntities: this.selectHelper.selectedEntities,
        };
        this.onSelectionChanged.emit(selectionChangedEvent);
    }
    columnSelected(entity, column, event) {
        var _a;
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        let columnSelectedEvent = {
            $event: event,
            column: column,
            entity: entity,
        };
        this.onColumnSelected.emit(columnSelectedEvent);
    }
    itemDeleted(entity, event) {
        var _a;
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        let itemDeletedEvent = {
            $event: event,
            entity: entity,
        };
        if (this.currentPage > 1 && this.entities.length === 1) {
            // decrement the current page if the item being deleted is the last thing on the page
            this.currentPage--;
            this.getEntities();
        }
        this.onItemDeleted.emit(itemDeletedEvent);
    }
    handleLinkFunction(entity, column, event) {
        var _a;
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        column.linkFunction(entity);
    }
    printModeChanged(printMode) {
        this.printMode = printMode;
        if (printMode) {
            this.currentPage = 1;
            this.itemsPerPage = this.entityListConfig.print.itemsPerPageInPrintMode;
            if (this.entityListConfig.print.automaticallyCallWindowPrint) {
                setTimeout(() => window.print(), 750);
            }
        }
        else {
            this.itemsPerPage = this._itemsPerPageInitial;
        }
        this.getEntities();
    }
    showDelete() {
        if (!this.entityListConfigDelete) {
            return false;
        }
        return this.entityListConfigDelete.showColumn(this.printMode);
    }
    getItemCounts() {
        return `${(this.currentPage - 1) * this.itemsPerPage + 1} - ${this.currentPage * this.itemsPerPage} of ${this.total}`;
    }
}
EntityListComponent.ɵfac = function EntityListComponent_Factory(t) { return new (t || EntityListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
EntityListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityListComponent, selectors: [["entity-list"]], contentQueries: function EntityListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, EntityListHeaderDirective, true, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, EntityListItemDirective, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
    } }, inputs: { emptyMessage: "emptyMessage", showItemCounts: "showItemCounts", showPagination: "showPagination", entities: "entities", selectedEntities: "selectedEntities", entityListConfig: "entityListConfig", itemsPerPage: "itemsPerPage", currentPage: "currentPage", total: "total" }, outputs: { itemsPerPageChange: "itemsPerPageChange", currentPageChange: "currentPageChange", onPageChanged: "onPageChanged", onItemSelected: "onItemSelected", onColumnSorted: "onColumnSorted", onColumnSelected: "onColumnSelected", onItemDeleted: "onItemDeleted", onSelectionChanged: "onSelectionChanged", ready: "ready" }, decls: 33, vars: 11, consts: [[3, "printModeChange", 4, "ngIf"], [3, "entityListConfig", 4, "ngIf"], [1, "table-responsive"], [1, "table", "table-hover", "table-striped", 3, "ngClass"], [4, "ngIf"], ["class", "no-pointer", 4, "ngIf"], [4, "ngIfPrintMode", "ngIf"], [3, "printModeChange"], [3, "entityListConfig"], [3, "width", "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "width", 4, "ngIf"], [3, "click"], ["class", "fa fa-lg fa-fw", "aria-hidden", "true", 3, "fa-check-square-o", "fa-square-o", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-lg", "fa-fw"], [3, "width", "ngStyle", "ngClass", "click", 4, "ngIf"], [3, "ngStyle", "ngClass", "click"], ["aria-hidden", "true", 1, "fa", "fa-sort-asc"], ["aria-hidden", "true", 1, "fa", "fa-sort-desc", 2, "margin-left", "-12px"], [1, "no-pointer"], [3, "ngTemplateOutlet"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], ["class", "ellipsis", 3, "background-color", "width", 4, "ngIf"], ["class", "ellipsis", 3, "background-color", "width", "mtConfirmOptions", "innerHtml", "mtConfirm", 4, "ngIf"], ["class", "ellipsis", 3, "background-color", "width", "innerHtml", "click", 4, "ngIf"], [1, "ellipsis"], ["class", "ellipsis", 3, "background-color", "width", "ngClass", "click", 4, "ngIf"], [3, "background-color", "width", "ngClass", 4, "ngIf"], [1, "ellipsis", 3, "ngClass", "click"], [3, "innerHTML", 4, "ngIf"], ["href", "javascript:void(0);", 3, "click", 4, "ngIf"], [3, "innerHTML"], ["href", "javascript:void(0);", 3, "click"], [3, "ngClass"], ["dynamicCell", "", 3, "componentRef", "item", "entityListComponentMembers"], [1, "ellipsis", 3, "mtConfirmOptions", "innerHtml", "mtConfirm"], [1, "ellipsis", 3, "innerHtml", "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "total", "currentPage", "itemsPerPage", "currentPageChange", "pageChange"], [1, "text-center"], [1, "item-counts", "text-muted"], [2, "text-align", "center"]], template: function EntityListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "entity-list-actions");
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵtemplate(3, EntityListComponent_entity_list_print_3_Template, 1, 0, "entity-list-print", 0);
        ɵngcc0.ɵɵtext(4, "\n            ");
        ɵngcc0.ɵɵtemplate(5, EntityListComponent_entity_list_export_5_Template, 1, 1, "entity-list-export", 1);
        ɵngcc0.ɵɵtext(6, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n        ");
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵtext(9, "\n            ");
        ɵngcc0.ɵɵelementStart(10, "table", 3);
        ɵngcc0.ɵɵtext(11, "\n                ");
        ɵngcc0.ɵɵelementStart(12, "thead");
        ɵngcc0.ɵɵtext(13, "\n                    ");
        ɵngcc0.ɵɵtemplate(14, EntityListComponent_tr_14_Template, 8, 3, "tr", 4);
        ɵngcc0.ɵɵtext(15, "\n                    ");
        ɵngcc0.ɵɵtemplate(16, EntityListComponent_tr_16_Template, 4, 1, "tr", 5);
        ɵngcc0.ɵɵtext(17, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n                ");
        ɵngcc0.ɵɵtemplate(19, EntityListComponent_tbody_19_Template, 4, 1, "tbody", 4);
        ɵngcc0.ɵɵtext(20, "\n                ");
        ɵngcc0.ɵɵtemplate(21, EntityListComponent_tbody_21_Template, 4, 1, "tbody", 4);
        ɵngcc0.ɵɵtext(22, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(23, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(24, "\n        ");
        ɵngcc0.ɵɵtemplate(25, EntityListComponent_div_25_Template, 4, 3, "div", 4);
        ɵngcc0.ɵɵtext(26, "\n        ");
        ɵngcc0.ɵɵtemplate(27, EntityListComponent_div_27_Template, 8, 6, "div", 4);
        ɵngcc0.ɵɵtext(28, "\n        ");
        ɵngcc0.ɵɵtemplate(29, EntityListComponent_div_29_Template, 5, 1, "div", 6);
        ɵngcc0.ɵɵtext(30, "\n        ");
        ɵngcc0.ɵɵtemplate(31, EntityListComponent_div_31_Template, 5, 1, "div", 4);
        ɵngcc0.ɵɵtext(32, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPrint);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.entityListConfig.hasExport);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngClass", ctx.entityListConfig.hasTableClass ? ctx.entityListConfig.tableClass : null);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.headerTemplate && ctx.entityListConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.itemTemplate && ctx.entityListConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemTemplate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPagination && ctx.pagingNeeded() && !ctx.printMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pagingNeeded() && ctx.printMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showItemCounts);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.noEntities());
    } }, directives: function () { return [EntityListActionsComponent, ɵngcc2.NgIf, ɵngcc2.NgClass, EntityListPrintComponent, EntityListExportComponent, ɵngcc2.NgForOf, ɵngcc2.NgStyle, ɵngcc2.NgTemplateOutlet, EntityListDynamicCellDirective, ɵngcc3.MtConfirmDirective, EntityListPaginationComponent]; }, pipes: function () { return [ɵngcc2.DecimalPipe]; }, styles: [".item-counts[_ngcontent-%COMP%] {\n                padding-left: 15px;\n                position: relative;\n                top: -20px;\n                font-style: italic;\n                font-size: small;\n            }"], changeDetection: 0 });
EntityListComponent.ctorParameters = () => [
    { type: Injector }
];
EntityListComponent.propDecorators = {
    entities: [{ type: Input, args: ['entities',] }],
    selectedEntities: [{ type: Input, args: ['selectedEntities',] }],
    entityListConfig: [{ type: Input, args: ['entityListConfig',] }],
    emptyMessage: [{ type: Input }],
    itemsPerPage: [{ type: Input, args: ['itemsPerPage',] }],
    itemsPerPageChange: [{ type: Output }],
    total: [{ type: Input }],
    showItemCounts: [{ type: Input }],
    currentPage: [{ type: Input }],
    currentPageChange: [{ type: Output }],
    onPageChanged: [{ type: Output }],
    onItemSelected: [{ type: Output }],
    onColumnSorted: [{ type: Output }],
    onColumnSelected: [{ type: Output }],
    onItemDeleted: [{ type: Output }],
    onSelectionChanged: [{ type: Output }],
    ready: [{ type: Output }],
    headerTemplate: [{ type: ContentChild, args: [EntityListHeaderDirective, { read: TemplateRef },] }],
    itemTemplate: [{ type: ContentChild, args: [EntityListItemDirective, { read: TemplateRef },] }],
    showPagination: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'entity-list',
                template: `
        <entity-list-actions>
            <entity-list-print *ngIf="hasPrint" (printModeChange)="printModeChanged($event)"></entity-list-print>
            <entity-list-export *ngIf="entityListConfig.hasExport" [entityListConfig]="entityListConfig"></entity-list-export>
        </entity-list-actions>
        <div class="table-responsive">
            <table class="table table-hover table-striped" [ngClass]="entityListConfig.hasTableClass ? entityListConfig.tableClass : null">
                <thead>
                    <tr *ngIf="!headerTemplate && entityListConfig">
                        <th
                            *ngIf="selectHelper.showSelect(printMode)"
                            [style.width.px]="selectHelper.selectConfig.width"
                            (click)="selectAllClicked($event)"
                        >
                            <i
                                *ngIf="selectHelper.isMultiSelect()"
                                class="fa fa-lg fa-fw"
                                aria-hidden="true"
                                [class.fa-check-square-o]="selectHelper.isAllItemsSelected(entities)"
                                [class.fa-square-o]="!selectHelper.isAllItemsSelected(entities)"
                            ></i>
                        </th>
                        <ng-container *ngFor="let column of columns">
                            <th
                                *ngIf="column.showColumn(printMode)"
                                [style.width.px]="column.style ? column.style.width : null"
                                [ngStyle]="{
                                    cursor: column.sort.disableSort ? 'auto' : 'pointer'
                                }"
                                [ngClass]="column.hasColumnClass ? column.getColumnClass(null) : null"
                                (click)="columnSorted(column, $event)"
                            >
                                <b
                                    >{{ column.name }}
                                    <span *ngIf="column.sort && !column.sort.disableSort">
                                        <i
                                            [style.opacity]="column.sort.direction === sortEnum.Asc ? null : 0.4"
                                            class="fa fa-sort-asc"
                                            aria-hidden="true"
                                        ></i>
                                        <i
                                            [style.opacity]="column.sort.direction === sortEnum.Desc ? null : 0.4"
                                            style="margin-left: -12px"
                                            class="fa fa-sort-desc"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </b>
                            </th>
                        </ng-container>
                        <th *ngIf="showDelete()" [style.width.px]="entityListConfigDelete.width">
                            <b>{{ entityListConfigDelete.headerText }}</b>
                        </th>
                    </tr>
                    <tr *ngIf="headerTemplate" class="no-pointer">
                        <ng-template [ngTemplateOutlet]="headerTemplate"> </ng-template>
                    </tr>
                </thead>
                <tbody *ngIf="!itemTemplate && entityListConfig">
                    <tr
                        *ngFor="let entity of entities"
                        (click)="itemSelected(entity, $event)"
                        [ngClass]="entityListConfig.hasRowClass ? entityListConfig.getRowClass(entity) : null"
                    >
                        <td
                            *ngIf="selectHelper.showSelect(printMode)"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="selectHelper.selectConfig.width"
                        >
                            <i
                                *ngIf="selectHelper.isSelectable(entity)"
                                class="fa fa-lg fa-fw"
                                aria-hidden="true"
                                [class.fa-check-square-o]="selectHelper.isItemSelected(entity)"
                                [class.fa-square-o]="!selectHelper.isItemSelected(entity)"
                            ></i>
                        </td>
                        <ng-container *ngFor="let column of columns">
                            <td
                                *ngIf="column.showColumn(printMode) && !column.component"
                                (click)="column.fireOnColumnSelected ? columnSelected(entity, column, $event) : null"
                                class="ellipsis"
                                [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                                [style.width.px]="column.style ? column.style.width : null"
                                [ngClass]="column.hasColumnClass ? column.getColumnClass(entity) : null"
                            >
                                <div *ngIf="column.bindToInnerHtml" [innerHTML]="column.getItemValue(entity, entityListPipeService)"></div>
                                <a *ngIf="column.linkFunction" (click)="handleLinkFunction(entity, column, $event)" href="javascript:void(0);">{{
                                    column.getItemValue(entity, entityListPipeService)
                                }}</a>
                                <div *ngIf="!column.bindToInnerHtml && !column.linkFunction">
                                    {{ column.getItemValue(entity, entityListPipeService) }}
                                </div>
                            </td>
                            <td
                                *ngIf="column.showColumn(printMode) && column.component"
                                [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                                [style.width.px]="column.style ? column.style.width : null"
                                [ngClass]="column.hasColumnClass ? column.getColumnClass(entity) : null"
                            >
                                <ng-container
                                    dynamicCell
                                    [componentRef]="column.component"
                                    [item]="entity"
                                    [entityListComponentMembers]="entityListComponentMembers"
                                >
                                </ng-container>
                            </td>
                        </ng-container>
                        <td
                            *ngIf="showDelete() && entityListConfigDelete.confirm && !entityListConfigDelete.component"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="entityListConfigDelete.width"
                            (mtConfirm)="itemDeleted(entity, $event)"
                            [mtConfirmOptions]="entityListConfigDelete.getConfirm(entity)"
                            [innerHtml]="entityListConfigDelete.getColumnHtml(entity)"
                        ></td>
                        <td
                            *ngIf="showDelete() && !entityListConfigDelete.confirm && !entityListConfigDelete.component"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="entityListConfigDelete.width"
                            (click)="itemDeleted(entity, $event)"
                            [innerHtml]="entityListConfigDelete.getColumnHtml(entity)"
                        ></td>
                        <td
                            *ngIf="showDelete() && entityListConfigDelete.component"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="entityListConfigDelete.width"
                        >
                            <ng-container
                                dynamicCell
                                [componentRef]="entityListConfigDelete.component"
                                [item]="entity"
                                [entityListComponentMembers]="entityListComponentMembers"
                            >
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="itemTemplate">
                    <ng-container *ngFor="let entity of entities">
                        <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: entity }"> </ng-template>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div *ngIf="showPagination && pagingNeeded() && !printMode">
            <entity-list-pagination
                [total]="total"
                [(currentPage)]="currentPage"
                [itemsPerPage]="itemsPerPage"
                (pageChange)="getEntities()"
            ></entity-list-pagination>
        </div>
        <div *ngIf="pagingNeeded() && printMode">
            <span class="text-center"
                ><em>limiting results to first {{ itemsPerPage | number }} of {{ total | number }}</em></span
            >
        </div>
        <div *ngIf="showItemCounts!; printMode">
            <span class="item-counts text-muted">{{ getItemCounts() }}</span>
        </div>
        <div *ngIf="noEntities()">
            <h3 style="text-align: center;">{{ emptyMessage }}</h3>
        </div>
    `,
                styles: [`
            .item-counts {
                padding-left: 15px;
                position: relative;
                top: -20px;
                font-style: italic;
                font-size: small;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { emptyMessage: [{
            type: Input
        }], itemsPerPageChange: [{
            type: Output
        }], showItemCounts: [{
            type: Input
        }], currentPageChange: [{
            type: Output
        }], onPageChanged: [{
            type: Output
        }], onItemSelected: [{
            type: Output
        }], onColumnSorted: [{
            type: Output
        }], onColumnSelected: [{
            type: Output
        }], onItemDeleted: [{
            type: Output
        }], onSelectionChanged: [{
            type: Output
        }], ready: [{
            type: Output
        }], showPagination: [{
            type: Input
        }], entities: [{
            type: Input,
            args: ['entities']
        }], selectedEntities: [{
            type: Input,
            args: ['selectedEntities']
        }], entityListConfig: [{
            type: Input,
            args: ['entityListConfig']
        }], itemsPerPage: [{
            type: Input,
            args: ['itemsPerPage']
        }], currentPage: [{
            type: Input
        }], total: [{
            type: Input
        }], headerTemplate: [{
            type: ContentChild,
            args: [EntityListHeaderDirective, { read: TemplateRef }]
        }], itemTemplate: [{
            type: ContentChild,
            args: [EntityListItemDirective, { read: TemplateRef }]
        }] }); })();

class EntityListActionsComponent {
}
EntityListActionsComponent.ɵfac = function EntityListActionsComponent_Factory(t) { return new (t || EntityListActionsComponent)(); };
EntityListActionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityListActionsComponent, selectors: [["entity-list-actions"]], ngContentSelectors: _c2, decls: 9, vars: 0, consts: [[1, "entity-list-actions"], [1, "entity-list-actions-container"]], template: function EntityListActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n                ");
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵtext(6, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n    ");
    } }, styles: [".entity-list-actions[_ngcontent-%COMP%] {\n                position: relative;\n            }\n            .entity-list-actions-container[_ngcontent-%COMP%] {\n                position: absolute;\n                top: -20px;\n                right: 0;\n            }"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListActionsComponent, [{
        type: Component,
        args: [{
                selector: 'entity-list-actions',
                template: `
        <div class="entity-list-actions">
            <div class="entity-list-actions-container">
                <ng-content></ng-content>
            </div>
        </div>
    `,
                styles: [`
            .entity-list-actions {
                position: relative;
            }
            .entity-list-actions-container {
                position: absolute;
                top: -20px;
                right: 0;
            }
        `]
            }]
    }], null, null); })();

function buildDataForExport(data, entityListConfig, entityListPipeService) {
    const columnsForExport = getColumnsForExport(entityListConfig);
    const dataToExport = getDataToExportMissingHeader(data, columnsForExport, entityListPipeService);
    return dataToExport;
}
function getColumnsForExport(entityListConfig) {
    return entityListConfig.columns
        .filter((column) => !column.excludeFromExport)
        .map((column) => {
        return column instanceof EntityListColumn ? column : new EntityListColumn(column);
    });
}
function getDataToExportMissingHeader(data, columnsForExport, entityListPipeService) {
    const dataToExport = data.map((item) => {
        const exportItem = {};
        columnsForExport.forEach((column) => {
            exportItem[column.name] = column.getItemValue(item, entityListPipeService);
        });
        return exportItem;
    });
    return dataToExport;
}

class EntityListExportService {
    constructor(entityListPipeService) {
        this.entityListPipeService = entityListPipeService;
    }
    export(data, entityListConfig) {
        if (!entityListConfig.export) {
            console.warn('EntityListExportService :: export :: entityListConfig is missing export property');
            return;
        }
        const dataToExport = buildDataForExport(data, entityListConfig, this.entityListPipeService);
        common.exportAsCsv(dataToExport, entityListConfig.export.exportName);
    }
}
EntityListExportService.ɵfac = function EntityListExportService_Factory(t) { return new (t || EntityListExportService)(ɵngcc0.ɵɵinject(EntityListPipeService)); };
EntityListExportService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EntityListExportService, factory: EntityListExportService.ɵfac });
EntityListExportService.ctorParameters = () => [
    { type: EntityListPipeService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListExportService, [{
        type: Injectable
    }], function () { return [{ type: EntityListPipeService }]; }, null); })();

class EntityListExportComponent {
    constructor(injector) {
        this.entityListExportService = injector.get(EntityListExportService);
    }
    export() {
        if (!this.entityListConfig.hasExport) {
            return;
        }
        if (this.entityListConfig.export.onExportClick) {
            this.entityListConfig.export.onExportClick();
        }
        if (this.entityListConfig.export.getDataForExport) {
            this.entityListConfig.export.getDataForExport().subscribe((data) => {
                this.entityListExportService.export(data, this.entityListConfig);
            });
        }
    }
}
EntityListExportComponent.ɵfac = function EntityListExportComponent_Factory(t) { return new (t || EntityListExportComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
EntityListExportComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityListExportComponent, selectors: [["entity-list-export"]], inputs: { entityListConfig: "entityListConfig" }, decls: 8, vars: 0, consts: [[1, "export-button"], ["type", "button", 1, "btn", "btn-default", "btn-xs", "btn-flat", 3, "click"], [1, "fa", "fa-xs", "fa-file-excel-o"]], template: function EntityListExportComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "span", 0);
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "button", 1);
        ɵngcc0.ɵɵlistener("click", function EntityListExportComponent_Template_button_click_3_listener() { return ctx.export(); });
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵtext(5, " Export");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n    ");
    } }, styles: [".export-button[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n                border-radius: 3px 3px 0 0;\n                background-color: #ccc;\n                border: 0;\n            }"] });
EntityListExportComponent.ctorParameters = () => [
    { type: Injector }
];
EntityListExportComponent.propDecorators = {
    entityListConfig: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListExportComponent, [{
        type: Component,
        args: [{
                selector: 'entity-list-export',
                template: `
        <span class="export-button">
            <button type="button" class="btn btn-default btn-xs btn-flat" (click)="export()"><i class="fa fa-xs fa-file-excel-o"></i> Export</button>
        </span>
    `,
                styles: [`
            .export-button .btn {
                border-radius: 3px 3px 0 0;
                background-color: #ccc;
                border: 0;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { entityListConfig: [{
            type: Input
        }] }); })();

class PrintModeService {
    constructor() {
        this.printMode = new BehaviorSubject(false);
    }
    togglePrintMode() {
        const toggledPrintMode = !this.printMode.getValue();
        this.printMode.next(toggledPrintMode);
    }
    closePrintMode() {
        if (this.printMode.getValue()) {
            this.togglePrintMode();
        }
    }
}
PrintModeService.ɵfac = function PrintModeService_Factory(t) { return new (t || PrintModeService)(); };
PrintModeService.ɵprov = ɵɵdefineInjectable({ factory: function PrintModeService_Factory() { return new PrintModeService(); }, token: PrintModeService, providedIn: "root" });
PrintModeService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PrintModeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class EntityListPrintComponent {
    constructor(injector) {
        this._printMode = false;
        this.printModeChange = new EventEmitter();
        this.subscriptions = new Subscription();
        this.printModeService = injector.get(PrintModeService);
    }
    set printMode(value) {
        this._printMode = value;
        this.printModeChange.emit(value);
    }
    get printMode() {
        return this._printMode;
    }
    ngOnInit() {
        this.subscriptions.add(this.printModeService.printMode.subscribe((printMode) => (this.printMode = printMode)));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.printModeService.closePrintMode();
    }
    togglePrintMode() {
        this.printModeService.togglePrintMode();
    }
}
EntityListPrintComponent.ɵfac = function EntityListPrintComponent_Factory(t) { return new (t || EntityListPrintComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
EntityListPrintComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityListPrintComponent, selectors: [["entity-list-print"]], outputs: { printModeChange: "printModeChange" }, decls: 5, vars: 2, consts: [["class", "close-print-button no-print", 4, "ngIf"], ["class", "print-button", 4, "ngIf"], [1, "close-print-button", "no-print"], ["type", "button", 1, "btn", "btn-default", "btn-flat", 3, "click"], [1, "print-button"], ["type", "button", 1, "btn", "btn-default", "btn-xs", "btn-flat", 3, "click"], [1, "fa", "fa-xs", "fa-print"]], template: function EntityListPrintComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, EntityListPrintComponent_div_1_Template, 5, 0, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, EntityListPrintComponent_span_3_Template, 6, 0, "span", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.printMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.printMode);
    } }, directives: [ɵngcc2.NgIf], styles: ["@media print {\n                @page {\n                    size[_ngcontent-%COMP%]:   landscape[_ngcontent-%COMP%];\n                }\n            }\n            .print-button[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n                border-radius: 3px 3px 0 0;\n                background-color: #ccc;\n                border: 0;\n            }\n            .close-print-button[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n                position: fixed;\n                top: 25px;\n                right: 25px;\n            }"] });
EntityListPrintComponent.ctorParameters = () => [
    { type: Injector }
];
EntityListPrintComponent.propDecorators = {
    printModeChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListPrintComponent, [{
        type: Component,
        args: [{
                selector: 'entity-list-print',
                template: `
        <div *ngIf="printMode" class="close-print-button no-print">
            <button type="button" class="btn btn-default btn-flat" (click)="togglePrintMode()">Close Print View</button>
        </div>
        <span *ngIf="!printMode" class="print-button">
            <button type="button" class="btn btn-default btn-xs btn-flat" (click)="togglePrintMode()"><i class="fa fa-xs fa-print"></i> Print</button>
        </span>
    `,
                styles: [`
            @media print {
                @page {
                    size: landscape;
                }
            }
            .print-button .btn {
                border-radius: 3px 3px 0 0;
                background-color: #ccc;
                border: 0;
            }
            .close-print-button .btn {
                position: fixed;
                top: 25px;
                right: 25px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { printModeChange: [{
            type: Output
        }] }); })();

class VirtualScrollEntityListComponent extends EntityListComponent {
    constructor(injector) {
        super(injector);
        this.showInfoBar = true;
        this.totalLabelSuffix = ' total';
        this.makeHeaderSticky = true;
        this.defaultStickyHeaderConfig = { top: 50, background: '#ccc', color: null };
        this._stickyHeaderConfig = this.defaultStickyHeaderConfig;
        this.defaultGetMoreConfig = { bottomOfListOffset: '100px' };
        this._getMoreConfig = this.defaultGetMoreConfig;
        this.getMore = new EventEmitter();
        this.bottomOfListInView = false;
        this.isScrolledDown = false;
        this.document = injector.get(DOCUMENT);
        this.LocaleId = injector.get(LOCALE_ID);
    }
    set entities(value) {
        this._entities = value;
        setTimeout(() => {
            this.handleGetMoreCheck();
        }, 200);
    }
    get entities() {
        if (!this._entities) {
            this._entities = [];
        }
        return this._entities;
    }
    set stickyHeaderConfig(value) {
        this._stickyHeaderConfig = Object.assign({}, this.defaultStickyHeaderConfig, value);
    }
    get stickyHeaderConfig() {
        return this._stickyHeaderConfig;
    }
    set getMoreConfig(value) {
        this._getMoreConfig = Object.assign({}, this.defaultGetMoreConfig, value);
    }
    get getMoreConfig() {
        return this._getMoreConfig;
    }
    formattedTotal() {
        if (this.total > 0) {
            return `${formatNumber(this.total, this.LocaleId)}${this.totalLabelSuffix}`;
        }
        return '';
    }
    bottomOfListInViewChanged(inView) {
        this.bottomOfListInView = inView;
        this.handleGetMoreCheck();
    }
    handleGetMoreCheck() {
        var _a, _b, _c;
        if (this.bottomOfListInView) {
            const moreToGet = ((_a = this.total) !== null && _a !== void 0 ? _a : 0) > ((_c = (_b = this.entities) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0);
            if (moreToGet) {
                this.getMore.emit();
            }
        }
    }
    scrollToTop() {
        this.document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
VirtualScrollEntityListComponent.ɵfac = function VirtualScrollEntityListComponent_Factory(t) { return new (t || VirtualScrollEntityListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
VirtualScrollEntityListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VirtualScrollEntityListComponent, selectors: [["virtual-scroll-entity-list"]], inputs: { showInfoBar: "showInfoBar", totalLabelSuffix: "totalLabelSuffix", makeHeaderSticky: "makeHeaderSticky", entities: "entities", stickyHeaderConfig: "stickyHeaderConfig", getMoreConfig: "getMoreConfig" }, outputs: { getMore: "getMore" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 26, vars: 18, consts: [["offset", "0px", 3, "inViewHasChanged"], [1, "table-responsive"], [1, "table", "table-hover", "table-striped", 3, "ngClass"], [4, "ngIf"], ["class", "no-pointer", 4, "ngIf"], ["class", "info-bar no-pointer", 4, "ngIf"], [3, "offset", "inViewHasChanged"], [3, "width", "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "width", 4, "ngIf"], [3, "click"], ["class", "fa fa-lg fa-fw", "aria-hidden", "true", 3, "fa-check-square-o", "fa-square-o", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-lg", "fa-fw"], [3, "width", "ngStyle", "ngClass", "click", 4, "ngIf"], [3, "ngStyle", "ngClass", "click"], ["aria-hidden", "true", 1, "fa", "fa-sort-asc"], ["aria-hidden", "true", 1, "fa", "fa-sort-desc", 2, "margin-left", "-12px"], [1, "no-pointer"], [3, "ngTemplateOutlet"], [1, "info-bar", "no-pointer"], ["colspan", "100"], ["class", "scroll-to-top-btn", 4, "ngIf"], [1, "scroll-to-top-btn"], ["href", "javascript:void(0)", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-arrow-up"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], ["class", "ellipsis", 3, "background-color", "width", 4, "ngIf"], ["class", "ellipsis", 3, "background-color", "width", "mtConfirmOptions", "innerHtml", "mtConfirm", 4, "ngIf"], ["class", "ellipsis", 3, "background-color", "width", "innerHtml", "click", 4, "ngIf"], [1, "ellipsis"], ["class", "ellipsis", 3, "background-color", "width", "ngClass", "click", 4, "ngIf"], [3, "background-color", "width", "ngClass", 4, "ngIf"], [1, "ellipsis", 3, "ngClass", "click"], [3, "innerHTML", 4, "ngIf"], ["href", "javascript:void(0);", 3, "click", 4, "ngIf"], [3, "innerHTML"], ["href", "javascript:void(0);", 3, "click"], [3, "ngClass"], ["dynamicCell", "", 3, "componentRef", "item", "entityListComponentMembers"], [1, "ellipsis", 3, "mtConfirmOptions", "innerHtml", "mtConfirm"], [1, "ellipsis", 3, "innerHtml", "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [2, "text-align", "center"]], template: function VirtualScrollEntityListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "scroll-check", 0);
        ɵngcc0.ɵɵlistener("inViewHasChanged", function VirtualScrollEntityListComponent_Template_scroll_check_inViewHasChanged_1_listener($event) { return ctx.isScrolledDown = !$event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n            ");
        ɵngcc0.ɵɵelementStart(5, "table", 2);
        ɵngcc0.ɵɵtext(6, "\n                ");
        ɵngcc0.ɵɵelementStart(7, "thead");
        ɵngcc0.ɵɵtext(8, "\n                    ");
        ɵngcc0.ɵɵtemplate(9, VirtualScrollEntityListComponent_tr_9_Template, 8, 3, "tr", 3);
        ɵngcc0.ɵɵtext(10, "\n                    ");
        ɵngcc0.ɵɵtemplate(11, VirtualScrollEntityListComponent_tr_11_Template, 4, 1, "tr", 4);
        ɵngcc0.ɵɵtext(12, "\n                    ");
        ɵngcc0.ɵɵtemplate(13, VirtualScrollEntityListComponent_tr_13_Template, 10, 2, "tr", 5);
        ɵngcc0.ɵɵtext(14, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15, "\n                ");
        ɵngcc0.ɵɵtemplate(16, VirtualScrollEntityListComponent_tbody_16_Template, 4, 1, "tbody", 3);
        ɵngcc0.ɵɵtext(17, "\n                ");
        ɵngcc0.ɵɵtemplate(18, VirtualScrollEntityListComponent_tbody_18_Template, 4, 1, "tbody", 3);
        ɵngcc0.ɵɵtext(19, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n        ");
        ɵngcc0.ɵɵtemplate(22, VirtualScrollEntityListComponent_div_22_Template, 5, 1, "div", 3);
        ɵngcc0.ɵɵtext(23, "\n        ");
        ɵngcc0.ɵɵelementStart(24, "scroll-check", 6);
        ɵngcc0.ɵɵlistener("inViewHasChanged", function VirtualScrollEntityListComponent_Template_scroll_check_inViewHasChanged_24_listener($event) { return ctx.bottomOfListInViewChanged($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(25, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵstyleProp("border-collapse", ctx.makeHeaderSticky ? "separate" : null);
        ɵngcc0.ɵɵproperty("ngClass", ctx.entityListConfig.hasTableClass ? ctx.entityListConfig.tableClass : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("position", ctx.makeHeaderSticky ? "sticky" : null)("top", ctx.makeHeaderSticky && ctx.stickyHeaderConfig.top ? ctx.stickyHeaderConfig.top : null, "px")("background", ctx.makeHeaderSticky && ctx.stickyHeaderConfig.background ? ctx.stickyHeaderConfig.background : null)("color", ctx.makeHeaderSticky && ctx.stickyHeaderConfig.color ? ctx.stickyHeaderConfig.color : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.headerTemplate && ctx.entityListConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showInfoBar && ctx.total > 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.itemTemplate && ctx.entityListConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemTemplate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.noEntities());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("offset", ctx.getMoreConfig.bottomOfListOffset);
    } }, directives: function () { return [ɵngcc4.ScrollCheckComponent, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgStyle, ɵngcc2.NgTemplateOutlet, EntityListDynamicCellDirective, ɵngcc3.MtConfirmDirective]; }, styles: ["table[_ngcontent-%COMP%] {\n                border-collapse: separate; \n            }\n            .info-bar[_ngcontent-%COMP%]   th[_ngcontent-%COMP%] {\n                font-weight: 400;\n                padding-top: 1px;\n                font-size: 0.85em;\n                padding-bottom: 0;\n                padding-left: 18px;\n            }\n            .scroll-to-top-btn[_ngcontent-%COMP%] {\n                padding-left: 30px;\n            }"], changeDetection: 0 });
VirtualScrollEntityListComponent.ctorParameters = () => [
    { type: Injector }
];
VirtualScrollEntityListComponent.propDecorators = {
    entities: [{ type: Input, args: ['entities',] }],
    showInfoBar: [{ type: Input }],
    totalLabelSuffix: [{ type: Input }],
    makeHeaderSticky: [{ type: Input }],
    stickyHeaderConfig: [{ type: Input }],
    getMoreConfig: [{ type: Input }],
    getMore: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VirtualScrollEntityListComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'virtual-scroll-entity-list',
                template: `
        <scroll-check (inViewHasChanged)="isScrolledDown = !$event" offset="0px"></scroll-check>
        <div class="table-responsive">
            <table
                class="table table-hover table-striped"
                [style.border-collapse]="makeHeaderSticky ? 'separate' : null"
                [ngClass]="entityListConfig.hasTableClass ? entityListConfig.tableClass : null"
            >
                <thead
                    [style.position]="makeHeaderSticky ? 'sticky' : null"
                    [style.top.px]="makeHeaderSticky && stickyHeaderConfig.top ? stickyHeaderConfig.top : null"
                    [style.background]="makeHeaderSticky && stickyHeaderConfig.background ? stickyHeaderConfig.background : null"
                    [style.color]="makeHeaderSticky && stickyHeaderConfig.color ? stickyHeaderConfig.color : null"
                >
                    <tr *ngIf="!headerTemplate && entityListConfig">
                        <th
                            *ngIf="selectHelper.showSelect(printMode)"
                            [style.width.px]="selectHelper.selectConfig.width"
                            (click)="selectAllClicked($event)"
                        >
                            <i
                                *ngIf="selectHelper.isMultiSelect()"
                                class="fa fa-lg fa-fw"
                                aria-hidden="true"
                                [class.fa-check-square-o]="selectHelper.isAllItemsSelected(entities)"
                                [class.fa-square-o]="!selectHelper.isAllItemsSelected(entities)"
                            ></i>
                        </th>
                        <ng-container *ngFor="let column of columns">
                            <th
                                *ngIf="column.showColumn(printMode)"
                                [style.width.px]="column.style ? column.style.width : null"
                                [ngStyle]="{
                                    cursor: column.sort.disableSort ? 'auto' : 'pointer'
                                }"
                                [ngClass]="column.hasColumnClass ? column.getColumnClass(null) : null"
                                (click)="columnSorted(column, $event)"
                            >
                                <b
                                    >{{ column.name }}
                                    <span *ngIf="column.sort && !column.sort.disableSort">
                                        <i
                                            [style.opacity]="column.sort.direction === sortEnum.Asc ? null : 0.4"
                                            class="fa fa-sort-asc"
                                            aria-hidden="true"
                                        ></i>
                                        <i
                                            [style.opacity]="column.sort.direction === sortEnum.Desc ? null : 0.4"
                                            style="margin-left: -12px"
                                            class="fa fa-sort-desc"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </b>
                            </th>
                        </ng-container>
                        <th *ngIf="showDelete()" [style.width.px]="entityListConfigDelete.width">
                            <b>{{ entityListConfigDelete.headerText }}</b>
                        </th>
                    </tr>
                    <tr *ngIf="headerTemplate" class="no-pointer">
                        <ng-template [ngTemplateOutlet]="headerTemplate"> </ng-template>
                    </tr>
                    <tr *ngIf="showInfoBar && total > 0" class="info-bar no-pointer">
                        <th colspan="100">
                            <span>{{ formattedTotal() }}</span>
                            <span *ngIf="isScrolledDown && stickyHeaderConfig" class="scroll-to-top-btn"
                                ><a (click)="scrollToTop()" href="javascript:void(0)"
                                    ><i class="fa fa-arrow-up" aria-hidden="true"></i> back to top</a
                                ></span
                            >
                        </th>
                    </tr>
                </thead>
                <tbody *ngIf="!itemTemplate && entityListConfig">
                    <tr
                        *ngFor="let entity of entities"
                        (click)="itemSelected(entity, $event)"
                        [ngClass]="entityListConfig.hasRowClass ? entityListConfig.getRowClass(entity) : null"
                    >
                        <td
                            *ngIf="selectHelper.showSelect(printMode)"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="selectHelper.selectConfig.width"
                        >
                            <i
                                *ngIf="selectHelper.isSelectable(entity)"
                                class="fa fa-lg fa-fw"
                                aria-hidden="true"
                                [class.fa-check-square-o]="selectHelper.isItemSelected(entity)"
                                [class.fa-square-o]="!selectHelper.isItemSelected(entity)"
                            ></i>
                        </td>
                        <ng-container *ngFor="let column of columns">
                            <td
                                *ngIf="column.showColumn(printMode) && !column.component"
                                (click)="column.fireOnColumnSelected ? columnSelected(entity, column, $event) : null"
                                class="ellipsis"
                                [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                                [style.width.px]="column.style ? column.style.width : null"
                                [ngClass]="column.hasColumnClass ? column.getColumnClass(entity) : null"
                            >
                                <div *ngIf="column.bindToInnerHtml" [innerHTML]="column.getItemValue(entity, entityListPipeService)"></div>
                                <a *ngIf="column.linkFunction" (click)="handleLinkFunction(entity, column, $event)" href="javascript:void(0);">{{
                                    column.getItemValue(entity, entityListPipeService)
                                }}</a>
                                <div *ngIf="!column.bindToInnerHtml && !column.linkFunction">
                                    {{ column.getItemValue(entity, entityListPipeService) }}
                                </div>
                            </td>
                            <td
                                *ngIf="column.showColumn(printMode) && column.component"
                                [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                                [style.width.px]="column.style ? column.style.width : null"
                                [ngClass]="column.hasColumnClass ? column.getColumnClass(entity) : null"
                            >
                                <ng-container
                                    dynamicCell
                                    [componentRef]="column.component"
                                    [item]="entity"
                                    [entityListComponentMembers]="entityListComponentMembers"
                                >
                                </ng-container>
                            </td>
                        </ng-container>
                        <td
                            *ngIf="showDelete() && entityListConfigDelete.confirm && !entityListConfigDelete.component"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="entityListConfigDelete.width"
                            (mtConfirm)="itemDeleted(entity, $event)"
                            [mtConfirmOptions]="entityListConfigDelete.getConfirm(entity)"
                            [innerHtml]="entityListConfigDelete.getColumnHtml(entity)"
                        ></td>
                        <td
                            *ngIf="showDelete() && !entityListConfigDelete.confirm && !entityListConfigDelete.component"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="entityListConfigDelete.width"
                            (click)="itemDeleted(entity, $event)"
                            [innerHtml]="entityListConfigDelete.getColumnHtml(entity)"
                        ></td>
                        <td
                            *ngIf="showDelete() && entityListConfigDelete.component"
                            class="ellipsis"
                            [style.background-color]="selectHelper.isItemSelected(entity) ? selectHelper.selectConfig.selectedColor : null"
                            [style.width.px]="entityListConfigDelete.width"
                        >
                            <ng-container
                                dynamicCell
                                [componentRef]="entityListConfigDelete.component"
                                [item]="entity"
                                [entityListComponentMembers]="entityListComponentMembers"
                            >
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="itemTemplate">
                    <ng-container *ngFor="let entity of entities">
                        <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: entity }"> </ng-template>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div *ngIf="noEntities()">
            <h3 style="text-align: center;">{{ emptyMessage }}</h3>
        </div>
        <scroll-check (inViewHasChanged)="bottomOfListInViewChanged($event)" [offset]="getMoreConfig.bottomOfListOffset"></scroll-check>
    `,
                styles: [`
            table {
                border-collapse: separate; /* keeps border in place when sticky comes into play */
            }
            .info-bar th {
                font-weight: 400;
                padding-top: 1px;
                font-size: 0.85em;
                padding-bottom: 0;
                padding-left: 18px;
            }
            .scroll-to-top-btn {
                padding-left: 30px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { showInfoBar: [{
            type: Input
        }], totalLabelSuffix: [{
            type: Input
        }], makeHeaderSticky: [{
            type: Input
        }], getMore: [{
            type: Output
        }], entities: [{
            type: Input,
            args: ['entities']
        }], stickyHeaderConfig: [{
            type: Input
        }], getMoreConfig: [{
            type: Input
        }] }); })();

class EntityListPaginationComponent {
    constructor() {
        this.currentPageChange = new EventEmitter();
        this.pageChange = new EventEmitter();
    }
}
EntityListPaginationComponent.ɵfac = function EntityListPaginationComponent_Factory(t) { return new (t || EntityListPaginationComponent)(); };
EntityListPaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityListPaginationComponent, selectors: [["entity-list-pagination"]], inputs: { total: "total", itemsPerPage: "itemsPerPage", currentPage: "currentPage" }, outputs: { currentPageChange: "currentPageChange", pageChange: "pageChange" }, decls: 3, vars: 4, consts: [[3, "collectionSize", "page", "pageSize", "maxSize", "pageChange"]], template: function EntityListPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "ngb-pagination", 0);
        ɵngcc0.ɵɵlistener("pageChange", function EntityListPaginationComponent_Template_ngb_pagination_pageChange_1_listener($event) { return ctx.currentPage = $event; })("pageChange", function EntityListPaginationComponent_Template_ngb_pagination_pageChange_1_listener($event) { ctx.currentPageChange.emit(ctx.currentPage); return ctx.pageChange.emit($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("collectionSize", ctx.total)("page", ctx.currentPage)("pageSize", ctx.itemsPerPage)("maxSize", 5);
    } }, directives: [ɵngcc5.NgbPagination], encapsulation: 2 });
EntityListPaginationComponent.propDecorators = {
    total: [{ type: Input }],
    itemsPerPage: [{ type: Input }],
    currentPage: [{ type: Input }],
    currentPageChange: [{ type: Output }],
    pageChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'entity-list-pagination',
                template: `
        <ngb-pagination
            [collectionSize]="total"
            [(page)]="currentPage"
            [pageSize]="itemsPerPage"
            [maxSize]="5"
            (pageChange)="currentPageChange.emit(currentPage); pageChange.emit($event)"
        ></ngb-pagination>
    `
            }]
    }], function () { return []; }, { currentPageChange: [{
            type: Output
        }], pageChange: [{
            type: Output
        }], total: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], currentPage: [{
            type: Input
        }] }); })();

class EntityListConfig {
    constructor(config) {
        Object.assign(this, config);
    }
    get hasRowClass() {
        return this.rowClass ? true : false;
    }
    get hasExport() {
        return this.export && (this.export.getDataForExport || this.export.onExportClick) ? true : false;
    }
    getRowClass(entity) {
        if (typeof this.rowClass === 'function') {
            return this.rowClass(entity);
        }
        else {
            return this.rowClass;
        }
    }
    /**
     * Checks if the Table class was provided to apply to the table div
     */
    get hasTableClass() {
        return this.tableClass ? true : false;
    }
    /**
     * Checks if the config has a default for sort direction.  If not
     * it defaults to Asc.
     */
    getDefaultSortDirection() {
        let ret;
        for (let i = 0; i < this.columns.length; i++) {
            const col = this.columns[i];
            if (col.hasOwnProperty('sort') && col.sort.hasOwnProperty('defaultDirection')) {
                return col.sort.defaultDirection;
            }
        }
        return SortDirection.Asc;
    }
    /**
     * Checks if the config has a default for sort set.  If not
     * it just applies it to the first property.
     */
    getDefaultSortProperty() {
        let ret;
        for (let i = 0; i < this.columns.length; i++) {
            const col = this.columns[i];
            if (col.hasOwnProperty('sort') && col.sort.hasOwnProperty('isDefaultForSort') && col.sort.isDefaultForSort === true) {
                return col.sort.sortProperty;
            }
        }
        return this.columns[0].sort.sortProperty;
    }
}

class EntityListExportConfig {
    constructor(config) {
        Object.assign(this, config);
    }
}

class EntityListPrintConfig {
    constructor(itemsPerPageInPrintMode = 100, automaticallyCallWindowPrint = true) {
        this.itemsPerPageInPrintMode = itemsPerPageInPrintMode;
        this.automaticallyCallWindowPrint = automaticallyCallWindowPrint;
    }
}

class EntityListDynamicCellDirective {
    constructor(resolver, container) {
        this.resolver = resolver;
        this.container = container;
    }
    ngOnInit() {
        const factory = this.resolver.resolveComponentFactory(this.componentRef);
        this.component = this.container.createComponent(factory);
        this.component.instance.entity = this.item;
        this.component.instance.entityListComponentMembers = this.entityListComponentMembers;
    }
}
EntityListDynamicCellDirective.ɵfac = function EntityListDynamicCellDirective_Factory(t) { return new (t || EntityListDynamicCellDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
EntityListDynamicCellDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EntityListDynamicCellDirective, selectors: [["", "dynamicCell", ""]], inputs: { componentRef: "componentRef", item: "item", entityListComponentMembers: "entityListComponentMembers" } });
EntityListDynamicCellDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef }
];
EntityListDynamicCellDirective.propDecorators = {
    componentRef: [{ type: Input }],
    item: [{ type: Input }],
    entityListComponentMembers: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListDynamicCellDirective, [{
        type: Directive,
        args: [{
                selector: '[dynamicCell]'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }]; }, { componentRef: [{
            type: Input
        }], item: [{
            type: Input
        }], entityListComponentMembers: [{
            type: Input
        }] }); })();

class EntityListModule {
}
EntityListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EntityListModule });
EntityListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EntityListModule_Factory(t) { return new (t || EntityListModule)(); }, providers: [
        IsPrimaryPipe,
        PhonePipe,
        AddressPipe,
        DatePipe,
        UpperCasePipe,
        LowerCasePipe,
        CurrencyPipe,
        PercentPipe,
        DecimalPipe,
        EntityListPipeService,
        EntityListExportService,
    ], imports: [[CommonModule, NgbModule, FormsModule, MtAlertsModule, VisibilityModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EntityListModule, { declarations: function () { return [EntityListComponent, EntityListHeaderDirective, EntityListItemDirective, AddressPipe, EntityListPrintComponent, EntityListDynamicCellDirective, EntityListActionsComponent, EntityListExportComponent, EntityListPaginationComponent, VirtualScrollEntityListComponent]; }, imports: function () { return [CommonModule, NgbModule, FormsModule, MtAlertsModule, VisibilityModule]; }, exports: function () { return [EntityListComponent, EntityListPaginationComponent, EntityListHeaderDirective, EntityListItemDirective, AddressPipe, VirtualScrollEntityListComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityListModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    EntityListComponent,
                    EntityListHeaderDirective,
                    EntityListItemDirective,
                    AddressPipe,
                    EntityListPrintComponent,
                    EntityListDynamicCellDirective,
                    EntityListActionsComponent,
                    EntityListExportComponent,
                    EntityListPaginationComponent,
                    VirtualScrollEntityListComponent,
                ],
                exports: [
                    EntityListComponent,
                    EntityListPaginationComponent,
                    EntityListHeaderDirective,
                    EntityListItemDirective,
                    AddressPipe,
                    VirtualScrollEntityListComponent,
                ],
                imports: [CommonModule, NgbModule, FormsModule, MtAlertsModule, VisibilityModule],
                providers: [
                    IsPrimaryPipe,
                    PhonePipe,
                    AddressPipe,
                    DatePipe,
                    UpperCasePipe,
                    LowerCasePipe,
                    CurrencyPipe,
                    PercentPipe,
                    DecimalPipe,
                    EntityListPipeService,
                    EntityListExportService,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AddressPipe, ColumnShowOnPrint, EntityListActionsComponent, EntityListColumn, EntityListComponent, EntityListConfig, EntityListDeleteColumn, EntityListExportComponent, EntityListExportConfig, EntityListExportService, EntityListHeaderDirective, EntityListItemDirective, EntityListModule, EntityListPaginationComponent, EntityListPipeService, EntityListPrintComponent, EntityListPrintConfig, EntityListSelectColumn, EntityListSelectHelper, PrintModeService, SelectTypes, SortDirection, VirtualScrollEntityListComponent, buildEntityListApi, EntityListDynamicCellDirective as ɵa };

//# sourceMappingURL=mt-ng2-entity-list-module.js.map